'use strict';
(function($){
    /*
     * vetology.map widget
     *
     * @description		Map's functionality for the platform.
     *
     * @param Object geo		Holds the geolocation options
                         @param Integer heightModifier	The map is set to a min-height and will resize on page resize
                                                        when that happens this modifier will be used to use windows height
                                                        minus this to set the maps height.
                         @param String apiKey			This is the API key used by the map.
                        @param Array map				This is the container of the map, all settings for the map will
                                                        be applied to this container.
                        @param Integer initialZoom		This is the zoom that the map will be rendered with initially.
                        @param Integer minimumZoom		This is the minimum zoom that the map will be allowed to have.
                        @param Array maps				An Array of maps containing all map instances.
                        @param Array inMap				An Array of place_ids that have already been added to the map.
     * @param {mixed} {any}		Any other parameter used in the platform widget will be described when created.
     *
     *
     */
    $.widget(
        'Vetology.gmap',
        {
            options: {
                height		: 250,
                map			: $('.geoMap')[0],
                _map		: $('.geoMap'),
                initialZoom	: 13,
                minimumZoom	: 5,
                maps		: [],
                trendMarkers: [],
                trends		: [],
                inMap		: [],
                inNetwork	: {},
                requested	: {},
                request		: {},
                denied		: {},
                youDenied	: {},
                userSHs		: {},
                inNet		: {},
                deniedNet	: {},
                SHs			: [],
                markers		: {},
                activeRequests : [],
                specialty	: false,
                sikkaClinics: {},
                availability_google_maps : false,
                last_type_selected: ''
            },
            /*
             * vetology.map._addressFinder
             *
             * @description	Enable address search on input fields, the search will be done in the sibling map
             *
             * @return NULL
             *
             */
            setupMaps	: function(){
                var o = this;
                var sPageURL = window.location.href.split("?");
                var sh_pid = false;
                var pm_only = false;
                if(typeof sPageURL[1] != "undefined" && sPageURL[1].length > 0){
                    sPageURL = sPageURL[1].split("&");
                    $.each(sPageURL, function(i, uri_component){
                        uri_component = uri_component.split("=");
                        if(uri_component[0] == "sh_pid" && uri_component[1] != ''){
                            sh_pid = uri_component[1];
                        }
                        if(uri_component[0] == "pm_only"){
                            pm_only = true;
                        }
                    });
                }
                if(typeof window.existingClinics == "object" && window.existingClinics.length > 0){
                    $.each(window.existingClinics, function(i, c){
                        o.options.sikkaClinics[c.GooglePlaceID] = c;
                    });
                }
                if (typeof userSHs != 'undefined') {
                    o.setupMapsProcessSHs(userSHs, sh_pid, pm_only);
                }
                if(typeof inNet != 'undefined'){
                    $.each(inNet, function(i,e){
                        o.options.inNetwork[e.GooglePlaceID] = {};
                        o.options.inNet[e.GooglePlaceID] = {};
                    });
                }
                if(typeof deniedNet != 'undefined'){
                    $.each(deniedNet, function(i,e){
                        o.options.denied[e.place_id_sp] = e;
                        o.options.deniedNet[e.place_id_sp] = e;
                    });
                }
                o.options.SHs['ChIJeaFoK6jw24ARj9wCJaqXaoI'] = 'ChIJeaFoK6jw24ARj9wCJaqXaoI';
                o.options.SHs['ChIJ_drtMZr_24ARUFB2xff4UoU'] = 'ChIJ_drtMZr_24ARUFB2xff4UoU';
                if(typeof specialtyClinics != 'undefined'){
                    $.each(specialtyClinics, function(i, SH){
                        o.options.SHs[SH.place_id] = SH;
                    });
                }
                if(typeof requests != 'undefined' && requests.length > 0){
                    $('.ocrRequests').removeClass('hide');
                    $.each(requests, function(i,e){
                        o.options.activeRequests[e.sh.GooglePlaceID] = e;
                    });
                }
                if(typeof clinicsRequested != 'undefined'){
                    $.each(clinicsRequested, function(i,e){
                        o.options.requested[e.place_id] = e;
                    });
                }
                if(typeof clinicsAskedRequest != 'undefined'){
                    $.each(clinicsAskedRequest, function(i,e){
                        o.options.request[e.place_id] = e;
                    });
                }
                if(typeof clinicsDenied != 'undefined'){
                    $.each(clinicsDenied, function(i,e){
                        o.options.denied[e.place_id] = e;
                        o.options.deniedNet[e.place_id] = e;
                    });
                }
                if(typeof clinicsYouDenied != 'undefined'){
                    $.each(clinicsYouDenied, function(i,e){
                        o.options.youDenied[e.place_id] = e;
                    });
                }
                o._events();
                o._resizeMap();
                o._initMap();
                o._fw('setMap', o);
            },
            setupMapsProcessSHs: function (userSHs, sh_pid, pm_only) {
                const o = this;
                var isset = 0;
                if(sh_pid != '') {
                    $.each(userSHs, function (i, SH) {
                        if (SH.place_id == sh_pid) {
                            isset = i;
                        }
                    });
                }
                o.options.specialty = userSHs[isset];
                o.options.ownClinic = userSHs[isset];
                window.ownClinic = userSHs[isset];
                if (pm_only) {
                    o.options._map.data("map", "clinic_adder_pms");
                    o.options.pms_clinics = o.options.specialty.pms_referrals;
                    $("body").on("change", ".dataPullsToggle", function (e) {
                        if ($(this).is(":checked")) {
                            $(this).val(1);
                        } else {
                            $(this).val(0);
                        }
                    });
                    $("body").on("click", ".clinic_pms_adder", function (e) {
                        e.preventDefault();
                        o.options.info.close();
                        var el = $(this);
                        $(".clinic_pms_adder").removeClass("active_pms");
                        el.addClass("active_pms");
                        var alertTitle = "Please enter the details for " + el.html();
                        var message_box = '<div class="form-group"><label class="control-label" for="dataPullsToggle"><input value="1" checked="checked" class="dataPullsToggle" name="clinicDataPulls" type="checkbox"> Enable clinic\'s OCR data pulls. <a style="color:#2C88BC" href="/doc/one-click-referral-data-sources" target="_blank" class="vetology-faq" title="Click here to learn more"></a></label></div><div class="form-group"><textarea style="max-width: 100%; max-height: 200px; " class="form-control" name="shmessage" placeholder="Please join our network so we can easily distribute you related cases"></textarea></div>';
                        message_box += '<div class="form-group"><label class="col-sm-2 control-label" for="clinicEmail">Clinic email</label><div class="col-sm-10"><input name="clinicEmail" class="form-control " placeholder="Please enter the clinc\'s email" type="text"></div></div><div class="form-group"><label class="control-label" for="clinicnoEmail"><input name="clinicnoEmail" type="checkbox"> I don\'t have the clinic\'s email, please contact them for me.</label></div>';
                        message_box += '<div class="form-group"><label class="col-sm-4 control-label" for="clinicAddr">Clinic Address</label><div class="col-sm-8"><input name="clinicAddr" class="form-control " placeholder="Please enter the clinc\'s address" type="text"></div></div>';
                        $('body').Vetology(
                            'do',
                            [
                                'showPromptDialog',
                                alertTitle,
                                message_box,
                                function (data) {
                                    var dataPulls = data.clinicDataPulls;
                                    var email = data.clinicEmail;
                                    var message = data.shmessage;
                                    var address = data.clinicAddr;
                                    o._runPMSSearch(dataPulls, email, message, address);
                                }
                            ]
                        );
                    });
                } else if (o.options.specialty.pms_referrals.length > 0) {
                    var u = '/specialty-hospital/manage/clinic-sign-up?pm_only=1&sh_pid=' + o.options.specialty.place_id;
                    $(".sh_missing_clinics").removeClass("hide").find("a").attr("href", u);
                    $(".sh_missing_clinics").find("span").html(o.options.specialty.name);
                }
                if (userSHs.length > 1) {
                    $(".sh_selector_warn").removeClass("hide");
                }
                $.each(userSHs, function (i, SH) {
                    o.options.userSHs[SH.place_id] = SH;
                    $.each(SH.ocrClinics, function (i, clinic) {
                        o.options.inNetwork[clinic.place_id] = clinic;
                    });
                    var option = $("<option></option>");
                    option.html(SH.name);
                    option.data("id", SH.ClinicID);
                    option.data("object", SH.place_id);
                    if (o.options.specialty.place_id == SH.place_id) {
                        option.attr("selected", "selected");
                    }
                    $(".sh_selector").append(option);
                });
                $("body").on("change", ".sh_selector", function () {
                    var el = $(this).find(":selected").data("object");
                    var url = window.location.href;
                    if (url.indexOf('?') !== -1) {
                        url += '&sh_pid=' + el;
                    } else {
                        url += '?sh_pid=' + el;
                    }
                    location.replace(url);
                });
            },

            /*
             * vetology.map._fw
             *
             * @description	Enable address search on input fields, the search will be done in the sibling map
             *
             * @return NULL
             *
             */
            _fw	: function(){
                return $('body').Vetology('do', arguments);
            },
            /*
             * vetology.map._addressFinder
             *
             * @description	Enable address search on input fields, the search will be done in the sibling map
             *
             * @return NULL
             *
             */
            _addressFinder	: function(){
                var o = this;
                $('.geoDetails').on('input', function(){
                    clearTimeout(o.options.searchFieldTO);
                    var address = '';
                    var values = [
                        'street_name',
                        'city',
                        'address_state',
                        'postal_code'
                    ];
                    var goAhead = true;
                    $.each(values, function(i,e){
                        var input = $('input.' + e);
                        if(input.val().length > 0){
                            switch(true){
                                case e == 'street_name':
                                    address += input.val() + ', ';
                                    break;
                                case e == 'city':
                                    address += input.val() + ', ';
                                    break;
                                case e == 'address_state':
                                    address += input.val() + ' ';
                                    break;
                                case e == 'postal_code':
                                    address += input.val();
                                    break;
                                default:
                                    break;
                            }
                        } else {
                            goAhead = false;
                        }
                    });
                    if(goAhead){
                        if(typeof o.options.mapSearch != 'undefined'){
                            clearTimeout(o.options.mapSearch);
                        }
                        o.options.mapSearch = setTimeout(
                            function(){
                                o.options.mapSearch = 'undefined';
                                $("body").Vetology("vetologyLoadStart", "Please wait while we find your address...");
                                var map = o.options.map;
                                o.options.searchFieldTO = setTimeout(
                                    function(){
                                        o._initGeoCoding(map);
                                        o.options.coder.geocode(
                                            {
                                                'address': address
                                            },
                                            function(results, status){
                                                if (status == google.maps.GeocoderStatus.OK){
                                                    $('.mapBlock').removeClass('disabledSection');
                                                    o._renderVeterinaryPlaces(results[0].geometry.location, 150,  map, 18);
                                                }
                                                $("body").Vetology("vetologyLoadEnd");
                                            }
                                        );
                                    },
                                    500);
                            }, 2000
                        );
                    }
                });
            },
            /*
             * vetology.map._initGeoCoding
             *
             * @description	Returns a label for the @item based on the @map preferences
             *
             * @param Object item	The item that contains the details for the label
             * @param Object map	The map that contains the exclusion for the label
             *
             * @return NULL
             *
             */
            _initGeoCoding	: function(map){
                if(typeof this.options.codingstarted == 'undefined'){
                    this.options.coder = new google.maps.Geocoder();
                    this.options.serviceSearch = new google.maps.places.PlacesService(map);
                    this.options.searchResults = [];
                }
            },
            /*
             * vetology.map._events
             *
             * @description	Enable event handlers for all items
             *
             * @return NULL
             *
             */
            _events	: function(){
                var o = this;
                /*
                setInterval(
                    function(){
                        o.options._map.toggleClass('seeMeeMarker');
                    },
                    500
                )*/
                if($('.geoDetails').length > 0){
                    this._addressFinder();
                }
                if($('.viewSignup').length > 0){
                    this._signUp();
                }
                $('body').on('click', '.getClinicHospitals', function(e){
                    e.preventDefault();
                    var lat = $(this).data('lat');
                    var lng = $(this).data('lng');
                    o._getSpecialtyHospitals(new google.maps.LatLng(lat, lng));
                });

                $('body').on('click', '.addClinicNow', function(e){
                    e.preventDefault();
                    var data = {
                        "country"	: $('.place_finder_country').val() === null ? '' : $('.place_finder_country').val().trim(),
                        "state"		: $('.place_finder_state').val().trim(),
                        "city"		: $('.place_finder_city').val().trim(),
                        "address"	: $('.place_finder_address').val().trim(),
                        "name"		: $('.place_finder_name').val().trim(),
                        "latitude"	: $('.place_finder_lat').val().trim(),
                        "longitude"	: $('.place_finder_lng').val().trim(),
                        "place_id"	: $('.place_finder_pid').val().trim(),
                    };
                    var continueProcessing = true;
                    $.each(data, function(i, e){
                        if(e.length < 1){
                            continueProcessing = false;
                        }
                    });
                    if(continueProcessing === false){
                        alert('All fields are required, make sure they are filled out.');
                        return;
                    }

                    data.phone = $('.place_finder_phone').val().trim();
                    data.fax = $('.place_finder_fax').val().trim();
                    data.zip = $('.place_finder_zip').val().trim();

                    var confirmText = "The Clinic " + data.name + " with below details will be added:\n";
                    confirmText += "Country " + data.country + "\n";
                    confirmText += "State " + data.state + "\n";
                    confirmText += "City " + data.city + "\n";
                    confirmText += "Zip/Postal Code " + data.zip + "\n";
                    confirmText += "Address " + data.address + "\n";
                    confirmText += "Latitude " + data.latitude + "\n";
                    confirmText += "Longitude " + data.longitude + "\n";
                    confirmText += "phone " + data.phone + "\n";
                    confirmText += "fax " + data.fax + "\n";
                    confirmText += "Google Place ID " + data.place_id + "\n";
                    var confirmInsert = confirm(confirmText);
                    if(confirmInsert){
                        $.ajax({
                            url: "/admin/clinics/new-insert",
                            method	: "POST",
                            data: data,
                            success: function(data){
                                if(data == 1){

                                    alert("Clinic Saved");
                                    location.reload();
                                } else {
                                    alert("Clinic could not be saved");
                                }
                            }
                        });
                    }
                });
            },
            /*
             * vetology.map._renderVeterinaryPlaces
             *
             * @description	Renders all markers on @map found at @location @radius and sets the @map's zoom level to @zoom
             *
             * @param Object location	The latLng Object where the search should take place
             * @param Integer radius	The radius to search based on @location's center
             * @param Object map		The map where search will take place and markers will be placed
             * @param Integer zoom		The zoom level that the @map should be set to
             *
             * @return NULL
             *
             */
            _renderVeterinaryPlaces	: function(location, radius,  map, zoom){
                var request = {
                    location	: location,
                    radius		: radius,
                    type		: 'veterinary_care',
                    keywords	: ['clinic','veterinary','hospital','emergency']
                };
                var zoomSet = false;
                if(zoom != 'setOnFirst'){
                    zoom = parseInt(zoom, 10) > 0 ? zoom : 15;
                    map.setZoom(zoom);
                    map.setCenter(location);
                }
                var o = this;
                o._initGeoCoding(map);
                o.options.serviceSearch.nearbySearch(
                    request,
                    function(results, success, pagination){
                        if(success == 'OK'){
                            $.each(results, function(i,e){
                                if(zoomSet === false && zoom == 'setOnFirst'){
                                    zoomSet = true;
                                    map.setZoom(18);
                                    map.setCenter(e.geometry.location);
                                }
                                o._renderMarker(e);
                            });
                            if(pagination && typeof pagination != 'undefined' && pagination.hasNextPage){
                                setTimeout(
                                    function(){
                                        pagination.nextPage();
                                    },
                                    2000
                                );
                            }
                        }
                    }
                );
            },
            /*
             * vetology.map._getAnalyticsMarkersLabel
             *
             * @description	Returns a label for the @clinic based on the @map preferences
             *
             * @param Object clinic	The clinic that contains the details for the label
             * @param Object map	The map that contains the exclusion for the label
             *
             * @return String		The label related to the @clinic
             *
             */
            _getAnalyticsMarkersLabel	: function(clinic){
                var o = this.options.trends;
                if(typeof o[clinic.GooglePlaceID] == 'undefined'){
                    return '';
                }
                var current = o[clinic.GooglePlaceID].CurrentPeriod;
                var previous = o[clinic.GooglePlaceID].Comparison;
                if(current === previous){
                    var trend = 'trend-same';
                    var difference = ' has same referrals compared to last period';
                } else if(current < previous) {
                    var trend = 'trend-down';
                    var difference = ' is down ' + (previous-current) + ' referral' + (previous-current > 1 ? 's' : '') + ' compared to last period';
                } else {
                    var trend = 'trend-up';
                    var difference = ' is up ' + (current-previous) + ' referral' + (current-previous > 1 ? 's' : '') + ' compared to last period';
                }
                var label = '<span class="crossWrapper cross-' + trend + '"><span data-content="' + clinic.ClinicName + difference + '" class="vmapMarker doPop vetology-clinic "></span><span class="thyCross"></span></span>';
                var label = '<span class="crossWrapper cross-' + trend + '"><span data-content="' + clinic.ClinicName + difference + '" class="vmapMarker doPop vetology-clinic "></span><span class="thyCross"></span></span>';
                return {
                    html: label,
                    content: clinic.ClinicName + difference
                };
            },
            /*
             * vetology.map._renderMarker
             *
             * @description	Renders a marker on @map at a given @item.geometry.location
             *
             * @param Object item	The item that contains the details to render the marker
             * @param Object map	The map where the marker will be rendered
             *
             * @return NULL
             *
             */
            _renderMarker	: function(item, center, showInfo){
                var o = this;
                if($.inArray(item.place_id, o.options.inMap) > -1){
                    return;
                }
                item.hasSikka = typeof o.options.sikkaClinics[item.place_id] != "undefined";
                item.sikkaSHEnabled = typeof o.options.inNetwork[item.place_id] != "undefined" && o.options.inNetwork[item.place_id].data_pull == 1;
                var map = o.options.map;
                var type = parseInt(o.options._map.data('type'), 10);
                var markerType = o._getMarkerType(item.name, item.place_id);
                if((type === 4 && markerType != 'specialty') || (type === 4 && ownClinic.place_id == item.place_id)){
                    return;
                } else if(type === 4 && !o._wasLoaded(item.place_id)){
                    o._addClinicToDB(item.place_id);
                }
                if (markerType == 'specialty' && $('.shFound').length > 0) {
                    
                    o.renderMarkerProcessSH(item);
                }
                this.options.inMap.push(item.place_id);
                var label = o._getMarkersLabel(item, map);
                var marker = new MarkerWithLabel(
                    {
                        position		: item.geometry.location,
                        draggable		: true,
                        raiseOnDrag		: false,
                        icon			: ' ',
                        map				: map,
                        labelAnchor		: new google.maps.Point(28, 25),
                        labelContent	: label,
                        labelClass		: ' clinicMarkerLabel '
                    }
                );
                marker.clinic = item;
                if (document.body.classList.contains('Vetology_class_UsersNearUs')) {
                    marker.addListener('click', (event) => {
                        const geoMap = event.target.closest('.geoMap');
                        const evt = new CustomEvent('geomap-marker-clicked', {
                            detail: {
                                originalEvent: event,
                                mapType: geoMap.dataset.type,
                                map: map,
                                marker: marker
                            }
                        });
                        document.dispatchEvent(evt);
                    });
                } else {
                    marker.addListener('click', function() {
                        var icon = $("[data-gpid=\"" + item.place_id + "\"]");
                        if(icon.length > 0 && typeof icon.data("reload") != "undefined"){
                            var active = icon.data("active");
                            var datapulls = icon.data("datapulls");
                            var clinicID = icon.data("clinic");
                            var name = icon.data("name");
                            var newMap = [];
                            $.each(o.options.inMap, function(i,tem){
                                if(item.place_id != tem){
                                    newMap.push(tem);
                                }
                            });
                            o.options.inMap = newMap;
                            var clinic = {
                                "ClinicID": clinicID,
                                "data_pull": datapulls,
                                "lat": item.geometry.location.lat(),
                                "lng": item.geometry.location.lng(),
                                "name": name,
                                "place_id": item.place_id,
                            };
                            o.options.inNetwork[item.place_id] = clinic;
                            return o._renderMarker(item, center, true);
                        } else {
                            o._showInfoMap($('.geoMap').data('type'), map, marker);
                        }
                    });
                }

                var settings = {
                    'trigger'	: 'hover',
                    'placement'	: 'auto',
                    'html'		: true,
                    'container'	: 'body',
                    'content'	: name,
                };
                if(center){
                    map.setCenter(item.geometry.location);
                    google.maps.event.trigger(marker, 'click');
                }
                if(showInfo){
                    o._showInfoMap($('.geoMap').data('type'), map, marker);
                }
                o.options.markers[item.place_id] = marker;
            },

            renderMarkerProcessSH: function (item) {
                const o = this;
                var count = parseInt($('.shcount').html(), 10);
                $('.shcount').html(count + 1);
                if(typeof o.options.inNet[item.place_id] != 'undefined') {
                    $('.shFound').append('<dt>In Network of:</a></dt><dd>' + item.name + '</dd>');
                } else if (typeof o.options.activeRequests[item.place_id] != 'undefined') {
                    var request = o.options.activeRequests[item.place_id];
                    if (request.direction == '1') {
                        $('.shFound').append('<dt><span href="#" class="requestMade" data-id="' + request.id + '">Request sent:</span></dt><dd>' + item.name + ' has received ' + ownClinic.name + '\'s request to be part of their Referral Network.</dd>');
                    } else {
                        $('.shFound').append('<dt><a data-id="' + request.id + '" class="acceptJoinNetwork label label-success" href="#">Accept</a> or <a data-id="' + request.id + '" class="denyJoinNetwork label label-danger" data-ref="' + item.place_id + '" href="#">Deny</a></a></dt><dd>' + item.name + ' has requested for your clinic to be part of their Referral Network.</dd>');
                    }
                } else if (typeof o.options.deniedNet[item.place_id] != 'undefined') {
                    var request = o.options.deniedNet[item.place_id];
                    if (request.direction == '1') {
                        $('.shFound').append('<dt><a class="joinNetworkSpecialtyHospital" data-join="' + ownClinic.clinic + '" data-requestingname="' + window.ownClinic.ClinicName + '" data-id="' + item.place_id + '" data-type="0" href="#">Request denied by:</a></dt><dd>' + item.name + '</dd>');
                    } else {
                        $('.shFound').append('<dt>Request denied:</dt><dd>' + ownClinic.name + ' has denided ' + item.name + '\'s request</dd>');
                    }
                } else {
                    $('.shFound').append('<dt><a class="joinNetworkSpecialtyHospital" data-join="' + ownClinic.clinic + '" data-requestingname="' + window.ownClinic.ClinicName + '" data-id="' + item.place_id + '" data-type="0" data-clinicname="' + item.name + '" href="#">Join Network of:</a></dt><dd>' + item.name + '</dd>');
                }
            },

            /*
             * vetology.map._getMarkersLabel
             *
             * @description	Returns a label for the @clinic based on the @map preferences
             *
             * @param Object clinic	The clinic that contains the details for the label
             * @param Object map	The map that contains the exclusion for the label
             *
             * @return String		The label related to the @clinic
             *
             */
            _getMarkersLabel	: function(clinic, map){
                var mtype = '';
                var markerType = this._getMarkerType(clinic.name, clinic.place_id);
                var l = '';
                if(markerType === 'own_specialty'){
                    l += 'specialty-hospital specialty-hospitalMarker';
                    mtype = clinic.hasSikka ? ' sikka_paid ' : '';
                }
                if (markerType === 'specialty') {
                    l += 'specialty-hospital specialty-hospitalMarker';
                    mtype = clinic.hasSikka ? ' sikka_paid ' : '';
                } else if(markerType === 'consultant') {
                    l += 'consultants consultantMarker';
                } else if(markerType === 'clinic_accepted') {
                    l += 'clinic clinicMarker requestAccepted';
                } else if(markerType === 'clinic_denied') {
                    l += 'clinic clinicMarker requestDenied';
                } else if(markerType === 'clinic_denied_by_you') {
                    l += 'clinic clinicMarker requestDeniedByYou';
                } else if(markerType === 'clinic_requested') {
                    l += 'clinic clinicMarker requestPending';
                } else if(markerType === 'clinic_request') {
                    l += 'clinic clinicMarker requestPending clinicRequest';
                } else if(markerType === 'clinic') {
                    l += 'clinic clinicMarker ';
                }
                var label = '<span data-gpid="' + clinic.place_id + '" data-content="' + clinic.name + '" class="';
                label += (clinic.hasSikka ? 'with_sikka' : (clinic.sikkaSHEnabled && markerType !== 'own_specialty' && markerType !== 'specialty' ? 'sikka_pending' : '')) + (clinic.sikkaSHEnabled ? ' sikka_paid ' : mtype) + ' vmapMarker doPop vetology-';
                label += l;
                var titleL = clinic.name.toLowerCase();
                label += '">' + (clinic.hasSikka || (clinic.sikkaSHEnabled && markerType !== 'own_specialty' && markerType !== 'specialty') ? '<i class="vetology-stack"></i>' : '') + '</span>';
                return label;
            },
            /*
             * vetology.map._runServiceSearch
             *
             * @description	Searches for clinics near the maps center, this method is dedicated only to SHs
             *
             * @return NULL
             *
             */
            _runPMSSearch	: function(dataPulls, email, message, address){
                var o = this;
                var el = $(".active_pms");
                el.data("email", email);
                el.data("message", message);
                el.data("dataPulls", dataPulls);
                if(typeof o.options.coder == "undefined"){
                    o.options.coder = new google.maps.Geocoder();
                }
                o.options.coder.geocode(
                    {
                        'address': address
                    },
                    function(results, status){
                        if (status == google.maps.GeocoderStatus.OK){
                            o._renderVeterinaryPlaces(results[0].geometry.location, 150,  o.options.map, 18);
                            //alert("Please click on the icon that belongs to " + el.html());
                        }
                        $("body").Vetology("vetologyLoadEnd");
                    }
                );
            },
            /*
             * vetology.map._runServiceSearch
             *
             * @description	Searches for clinics near the maps center, this method is dedicated only to SHs
             *
             * @return NULL
             *
             */
            _runServiceSearch	: function(){
                var o = this;
                if(o.options.searching === true){
                    return;
                }
                if (document.body.dataset.mousedown === "1") {
                    return;
                }
                o.options.searching = true;
                var map = o.options.map;
                var searchlocation = map.getCenter();
                var request = {
                    location	: searchlocation,
                    radius		: 1000,
                    type		: 'veterinary_care',  
                    keywords	: ['clinic','veterinary','hospital','emergency']
                };
                if(typeof this.options.serviceSearch == 'undefined'){
                    this._initGeoCoding(map);
                }
                this.options.serviceSearch.nearbySearch(
                    request,
                    function(results, success, pagination){
                        if(success == 'OK'){
                            $.each(results, function(i,e){
                                o._renderMarker(e, false, 0);
                            });
                            if(pagination && typeof pagination != 'undefined' && pagination.hasNextPage){
                                setTimeout(
                                    function(){
                                        pagination.nextPage();
                                    },
                                    500
                                );
                            } else {
                                o.options.searching = false;
                            }
                        } else {
                            o.options.searching = false;
                        }
                    }
                );
                request.radius = 10000;
                this.options.serviceSearch.nearbySearch(
                    request,
                    function(results, success, pagination){
                        if(success == 'OK'){
                            $.each(results, function(i,e){
                                o._renderMarker(e);
                            });
                            if(pagination && typeof pagination != 'undefined' && pagination.hasNextPage){
                                setTimeout(
                                    function(){
                                        pagination.nextPage();
                                    },
                                    500
                                );
                            }
                        }
                    }
                );
                request.radius = 50000;
                this.options.serviceSearch.nearbySearch(
                    request,
                    function(results, success, pagination){
                        if(success == 'OK'){
                            $.each(results, function(i,e){
                                o._renderMarker(e);
                            });
                            if(pagination && typeof pagination != 'undefined' && pagination.hasNextPage){
                                setTimeout(
                                    function(){
                                        pagination.nextPage();
                                    },
                                    500
                                );
                            }
                        }
                    }
                );
            },

            /*
             * vetology.map._initWelcomeSearch
             *
             * @description	Searches for clinics near the maps center, this method is dedicated only to SHs
             *
             * @return NULL
             *
             */
            _initWelcomeSearch	: function(){
                var o = this;
                var map = o.options.map;
                if($('.geoMap').data('place') != 'undefined'){
                    o.options.marker = new MarkerWithLabel(
                        {
                            position		: o.options.coordinates,
                            draggable		: false,
                            raiseOnDrag		: false,
                            icon			: ' ',
                            map				: map,
                            labelAnchor		: new google.maps.Point(28, 25),
                            labelContent	: '<span data-content="' + ownClinic.name + '" class="vmapMarker doPop vetology-clinic ownClinic"></span>',
                            labelClass		: ' clinicMarkerLabel '
                        }
                    );
                }
                $.each(ownClinic.nearByClinics, function(i,e){
                    o.options.SHs.push(e.place_id);
                    var place = {
                        place_id	: e.place_id,
                        name		: e.name,
                        geometry	: {
                            location	: new google.maps.LatLng(parseFloat(e.lat), parseFloat(e.lng)),
                        }
                    };
                    o._renderMarker(place);
                });
                this._runSpecialtyHospitalSearch();
            },

            /*
             * vetology.map._runRadarSearch
             *
             * @description	Searches for clinics near the maps center, this method is dedicated only to SHs
             *
             * @return NULL
             *
             */
            _runSpecialtyHospitalSearch	: function(){
                var o = this;
                var map = o.options.map;
                var searchlocation = map.getCenter();
                var request = {
                    location	: searchlocation,
                    radius		: 45000,
                    type		: 'veterinary_care',
                    query		: 'emergency or imaging'
                };
                /*
                 * Keywords : 'emergency, urgent, referral, special'
                 *
                 */
                if(typeof this.options.serviceSearch == 'undefined'){
                    this._initGeoCoding(map);
                }
                this.options.serviceSearch.textSearch(
                    request,
                    function(results, success, pagination){
                        if(success == 'OK'){
                            $.each(results, function(i,e){
                                o._renderMarker(e, false, 0);
                            });
                            if(pagination && typeof pagination != 'undefined' && pagination.hasNextPage){
                                setTimeout(
                                    function(){
                                        pagination.nextPage();
                                    },
                                    2000
                                );
                            } else {
                                var count = parseInt($('.shcount').html(), 10);
                                $('.logAllSHFound')
                                    .removeClass('callout-warning')
                                    .addClass('callout-success')
                                    .html('We found ' + count + ' Referral Center' + (count > 1 ? 's' : '') + ' near ' + ownClinic.name + ', if you like to join any of them click on the join network link below.');
                            }
                        }
                    }
                );
            },
            /*
             * vetology.map._wasLoaded
             *
             * @description	Renders a marker on @map at a given @item.geometry.location
             *
             * @param Object item	The item that contains the details to render the marker
             * @param Object map	The map where the marker will be rendered
             *
             * @return NULL
             *
             */
            _geoLocateData	: function(el, pms_only){
                var o = this;
                switch(true){
                    case pms_only:
                        o.options.service.textSearch({
                            "location": o.options.map.getCenter(),
                            "radius": 500,
                            "type": 'veterinary_care',
                            "query": "VICSD"
                        }, function(results, status){
                        });
                        break;
                    case el.hasClass('place_finder_state'):
                        $('.clinic_list').html('');
                        o.options.geocoder.geocode(
                            {'address' : $('.place_finder_state').val() + ', ' + $('.place_finder_country').val()},
                            function(results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    $('.place_finder_city').removeAttr('disabled');
                                    o.options.map.setCenter(results[0].geometry.location);
                                    o.options.map.setZoom(8);
                                    o.options.marker.setPosition(results[0].geometry.location);
                                }
                            }
                        );
                        break;
                    case el.hasClass('place_finder_city'):
                        $('.clinic_list').html('');
                        o.options.geocoder.geocode(
                            {'address' : $('.place_finder_city').val() + $('.place_finder_state').val() + ', ' + $('.place_finder_country').val()},
                            function(results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {

                                    $('.place_finder_zip').removeAttr('disabled');
                                    $('.place_finder_address').removeAttr('disabled');
                                    $('.place_finder_name').removeAttr('disabled');
                                    $('.place_finder_phone').removeAttr('disabled');
                                    $('.place_finder_fax').removeAttr('disabled');

                                    $('.place_finder_zip').removeAttr('disabled');
                                    o.options.map.setCenter(results[0].geometry.location);
                                    o.options.map.setZoom(10);
                                    o.options.marker.setPosition(results[0].geometry.location);
                                }
                            }
                        );
                        break;
                    case el.hasClass('place_finder_zip'):
                        $('.clinic_list').html('');
                        o.options.geocoder.geocode(
                            {'address' : $('.place_finder_city').val() + $('.place_finder_state').val() + ', ' + $('.place_finder_country').val() + ', ' + $('.place_finder_zip').val()},
                            function(results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {

                                    //Checking if it is necessary update the map by the zip input, as there are some locations that do not have postal codes established
                                    var componentsWithPostalCode = results[0].address_components.filter(function(address_component){
                                        return address_component.types.filter(function(type){ return type === 'postal_code'}).length > 0
                                    });

                                    if(componentsWithPostalCode.length > 0) {
                                        o.options.map.setCenter(results[0].geometry.location);
                                        o.options.map.setZoom(15);
                                        o.options.marker.setPosition(results[0].geometry.location);
                                    }
                                }
                            }
                        );
                        break;
                    case el.hasClass('place_finder_address'):
                        var address = $('.place_finder_address').val() + ', ' + $('.place_finder_city').val() + ', ' + $('.place_finder_state').val() + ', ' + $('.place_finder_country').val() + ', ' + $('.place_finder_zip').val();
                        o.options.foundPlaces = [];
                        clearTimeout(o.options.searchTO);
                        $('.clinic_list').html('');
                        o.options.searchTO = setTimeout(
                            function(){
                                o.options.geocoder.geocode(
                                    {'address' :  address},
                                    function(results, status) {
                                        if (status == google.maps.GeocoderStatus.OK) {
                                            o._showInfoMapAdder();
                                            var loc = results[0].geometry.location;
                                            o.options.map.setCenter(loc);
                                            o.options.map.setZoom(17);
                                            o.options.marker.setPosition(loc);
                                            var types = ['doctor','health', 'zoo', 'veterinary_care', 'pet_store', 'hospital', 'dentist'];
                                            var countComplete = 8;
                                            $.each(types, function(i, type){
                                                o._getPlacesAround(loc,type);
                                            });
                                        }
                                    }
                                );
                            },
                            1500
                        );
                        break;
                    case el.hasClass('place_finder_lat'): case el.hasClass('place_finder_lng'):

                        $('.place_finder_country').val('');
                        $('.place_finder_state').val('');
                        $('.place_finder_city').val('');
                        $('.place_finder_zip').val('');
                        $('.place_finder_address').val('');
                        $('.place_finder_name').val('');
                        $('.place_finder_phone').val('');
                        $('.place_finder_fax').val('');

                        $('.clinic_list').html('');
                        var latitude = parseFloat($('.place_finder_lat').val().trim());
                        var longitude = parseFloat($('.place_finder_lng').val().trim());
                        if(!isNaN(latitude) && !isNaN(longitude) && latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180){
                            o.geoLocateDataProcess(latitude, longitude);

                        }
                        break;
                }
            },


            geoLocateDataProcess: function(latitude, longitude) {
                const o = this;
                var position = new google.maps.LatLng(latitude, longitude);
                o.options.map.setCenter(position);
                o.options.marker.setPosition(position);
                o.options.geocoder.geocode(
                    { 'location': position },
                    function (results, status) {
                        o.options.map.setZoom(15);
                        if (status === google.maps.GeocoderStatus.OK) {
                            $('.place_finder_state').removeAttr('disabled');
                            $('.place_finder_city').removeAttr('disabled');
                            $('.place_finder_zip').removeAttr('disabled');
                            $('.place_finder_address').removeAttr('disabled');
                            $('.place_finder_name').removeAttr('disabled');
                            $('.place_finder_phone').removeAttr('disabled');
                            $('.place_finder_fax').removeAttr('disabled');

                            var placeIdFound = false;
                            if (results[1]) {
                                placeIdFound = o.getLocateDataProcessResults(results, placeIdFound);
                            }

                            if ($('.place_finder_address').val() !== '') {

                                o._geoLocateData($('.place_finder_address'));

                            }

                        } else {
                            window.alert('Geocoder failed due to: ' + status);
                        }
                    }
                );
            },

            getLocateDataProcessResults: function(results, placeIdFound) {
                $.each(results, function (i, r) {
                    if (typeof r.address_components != 'undefined') {

                        placeIdFound = true;
                        $('.place_finder_pid').val(r.place_id);
                        $('.place_finder_phone').val(r.international_phone_number);
                        $('.place_finder_fax').val(r.international_phone_number);

                        $.each(r.address_components, function (i, c) {
                            if (c.types[0] == 'country' || (typeof c.types[1] != 'undefined' && c.types[1] == 'country')) {
                                $('.place_finder_country').val(c.short_name);
                            } else if (c.types[0] == 'administrative_area_level_1' || (typeof c.types[1] != 'undefined' && c.types[1] == 'administrative_area_level_1')) {
                                $('.place_finder_state').val(c.short_name);
                            } else if (c.types[0] == 'locality' || (typeof c.types[1] != 'undefined' && c.types[1] == 'locality')) {
                                $('.place_finder_city').val(c.short_name);
                            } else if (c.types[0] == 'postal_code') {
                                $('.place_finder_zip').val(c.short_name);
                            } else if (c.types[0] == 'route') {
                                $('.place_finder_address').data('s', c.short_name);
                                $('.place_finder_address').val($('.place_finder_address').data('n') + ' ' + $('.place_finder_address').data('s'));
                            } else if (c.types[0] == 'street_number') {
                                $('.place_finder_address').data('n', c.short_name);
                                $('.place_finder_address').val($('.place_finder_address').data('n') + ' ' + $('.place_finder_address').data('s'));
                            }
                        });
                    }
                    if (r.address_components.length > 5) {
                        return false;
                    }
                });
                return placeIdFound;
            },



            /*
             * vetology.map._showInfoMapAdder
             *
             * @description	This method shows the information of a Clinic/Specialty or a Consultant
             *
             * @param Integer type	The type of info window needed
                                    0-2 Show the selection of the items for sign-up
             * @param Object map	The map where the infowindow will be displayed
             * @param Object marker The marker where the information of the item is stored along with coordinates
             *
             * @return NULL
             */
            _getPlacesAround: function(loc, type){
                var o = this;
                var service = new google.maps.places.PlacesService(o.options.map);
                service.nearbySearch({
                    location: loc,
                    type	: type,
                    radius	: 1000,
                    keywords	: ['clinic','veterinary','hospital','emergency']
                }, function(results, status, pagination){
                    if (status == google.maps.GeocoderStatus.OK) {
                        if(results[0]){
                            $.each(results, function(i,r){
                                var content = '<li>' +
                                    '<a href="#" data-id="' + r.place_id + '">' +
                                    '<span class="clinicAddName">' + r.name + ' ' + r.vicinity + '</span>' +
                                    '</a>' +
                                    '</li>';
                                $('.clinic_list').append(content);
                            });
                            if(pagination.hasNextPage){
                                setTimeout(
                                    function(){
                                        pagination.nextPage();
                                    },
                                    2000
                                );
                            }
                        }
                    }
                });
            },
            /*
             * vetology.map._showInfoMapAdder
             *
             * @description	This method shows the information of a Clinic/Specialty or a Consultant
             *
             * @param Integer type	The type of info window needed
                                    0-2 Show the selection of the items for sign-up
             * @param Object map	The map where the infowindow will be displayed
             * @param Object marker The marker where the information of the item is stored along with coordinates
             *
             * @return NULL
             */
            _showInfoMapAdder: function(results){
                var o = this;
                var content = '' +
                    '<div class="info-box">' +
                    '<span class="info-box-icon bg-yellow"><i class="vetology-clinic"></i></span>' +
                    '<div class="info-box-content">' +
                    '<ul class="clinic_list">' +
                    '</ul>' +
                    '</div>'+
                '</div>';
                this.options.info.setContent(content);
                this.options.info.open(o.options.map, o.options.marker);
                return;
            },
            /*
             * vetology.map._addSearchMarker
             *
             * @description	Renders a marker on @map at a given @item.geometry.location
             *
             * @param Object item	The item that contains the details to render the marker
             * @param Object map	The map where the marker will be rendered
             *
             * @return NULL
             *
             */
            _addSearchMarker : function(place_id){
                return typeof this.options.SHs[place_id] != 'undefined';
            },
            /*
             * vetology.map._wasLoaded
             *
             * @description	Renders a marker on @map at a given @item.geometry.location
             *
             * @param Object item	The item that contains the details to render the marker
             * @param Object map	The map where the marker will be rendered
             *
             * @return NULL
             *
             */
            _wasLoaded	: function(place_id){
                return typeof this.options.SHs[place_id] != 'undefined';
            },
            /*
             * vetology.map._renderAnalyticsMarker
             *
             * @description	Renders a marker on @map at a given @item.geometry.location
             *
             * @param Object item	The item that contains the details to render the marker
             * @param Object map	The map where the marker will be rendered
             *
             * @return NULL
             *
             */
            _renderAnalyticsMarker	: function(clinic){
                var o = this;
                var map = this.options.map;
                var label = o._getAnalyticsMarkersLabel(clinic);
                var settings = {
                    'trigger'	: 'hover',
                    'placement'	: 'auto',
                    'html'		: true,
                    'container'	: 'body',
                    'content'	: label.content,
                };
                label = label.html;
                var marker = new MarkerWithLabel(
                    {
                        position		: {lat:parseFloat(clinic.latitude), lng:parseFloat(clinic.longitude)},
                        draggable		: true,
                        raiseOnDrag		: false,
                        icon			: ' ',
                        map				: map,
                        labelAnchor		: new google.maps.Point(28, 25),
                        labelContent	: label,
                        labelClass		: ' clinicMarkerLabel '
                    }
                );
                o.options.trendMarkers.push(marker);
                /*google.maps.event.addListener(marker,'mouseover',function(e){
                    if(!label.hasClass('withPop')){
                        label.popover(settings).popover('show');
                        label.addClass('withPop');
                    } else {
                        label.popover('show');
                    }
                });
                google.maps.event.addListener(marker,'mouseout',function(e){
                    if(label.hasClass('withPop')){
                        label.popover('hide');
                    }
                });*/
                google.maps.event.addListener(marker,'click',function(e){
                    if(!label.hasClass('withPop')){
                        label.popover(settings).popover('show');
                        label.addClass('withPop');
                    } else {
                        label.popover('show');
                    }
                });
            },
            /*
             * vetology.map._signUp
             *
             * @description	Enable sign-up script
             *
             * @return NULL
             *
             */
            _signUp	: function(){
                var o = this;
                this.options.signUps = $('.viewSignup');
                this.options.signUps.on('click', function(e){
                    e.preventDefault();
                    var clicked = $(this);
                    clicked.closest('div').removeClass('opace5');
                    var display = clicked.data('block');
                    $('.geoMap').removeClass('specialtyHospitalBlock clinicBlock consultantBlock');
                    switch(display){
                        case 'specialtyHospitalBlock':
                            $('.geoMap').data('type', 1);
                            break;
                        case 'clinicBlock':
                            $('.geoMap').data('type', 2);
                            break;
                        case 'consultantBlock':
                            $('.geoMap').data('type', 0);
                            break;
                        default:
                            break;
                    }
                    $('.geoMap').addClass(display);
                    $('.viewSignupBlock').addClass('hide');
                    $('.secondSection').removeClass('disabledSection');
                    e.preventDefault();
                    if(o.options.last_type_selected !== display){
                        o.options.info.close();
                    }
                    o.options.last_type_selected = display;
                });
                $('body').on('click', '.itemSignUp', function(e){
                    e.preventDefault();
                    $("body").Vetology("vetologyLoadStart", "Checking for availability");
                    o._signUpAvailability($(this));
                });
            },
            /*
             * vetology.map._getMarkerType
             *
             * @description	This method returns the type of marker, Clinic, Specialty or Consutlant
             *
             * @param String title		The title used to identify the item type
             * @param String place_id	The Google place id of the clinic
             *
             * @return Integer		0 for Consultant, 1 for Specialty and 2 for Clinic
             *
             */
            _getMarkerType: function(title, place_id) {
                title = title.toLowerCase();
                var o = this;
                if(title.indexOf("dvm") >= 0) {
                    return 'consultant';
                } else if(typeof o.options.userSHs[place_id] != 'undefined'){
                    return 'own_specialty';
                } else if(
                    title.indexOf("eye care for animals") >= 0 ||
                    title.indexOf("bluepearl") >= 0 ||
                    title.indexOf("dental") >= 0 ||
                    title.indexOf("emergency") >= 0 ||
                    title.indexOf("urgent") >= 0 ||
                    title.indexOf("referral") >= 0 ||
                    title.indexOf("special") >= 0 ||
                    $.inArray(place_id, o.options.SHs) > -1 ||
                    typeof o.options.SHs[place_id] != 'undefined'
                ){
                    return 'specialty';
                }
                if(typeof o.options.requested[place_id] == 'undefined' && typeof o.options.inNetwork[place_id] != 'undefined'){
                    return 'clinic_requested';
                } else if(typeof o.options.request[place_id] != 'undefined' && typeof o.options.inNetwork[place_id] == 'undefined'){
                    return 'clinic_request';
                } else if(
                    typeof o.options.inNetwork[place_id] != 'undefined'
                ){
                    return 'clinic_accepted';
                } else if(
                    typeof o.options.denied[place_id] != 'undefined'
                ){
                    return 'clinic_denied';
                } else if(
                    typeof o.options.youDenied[place_id] != 'undefined'
                ){
                    return 'clinic_denied_by_you';
                }
                return 'clinic';
            },
            /*
             * vetology.map._signUpAvailability
             *
             * @description	This method runs on page resize and is meant to set the correct sizing for all elements on page.
             *
             * @param Object dom	The jQuery(DOM) element that was clicked
             *
             * @return NULL
             *
             */
            _addClinicToDB: function(place) {
                $.get(
                    '/add-sh',
                    {
                        id	: place
                    },
                    function(available, status){
                    },
                    'JSON'
                );
            },
            /*
             * vetology.map._signUpAvailability
             *
             * @description	This method runs on page resize and is meant to set the correct sizing for all elements on page.
             *
             * @param Object dom	The jQuery(DOM) element that was clicked
             *
             * @return NULL
             *
             */
            _signUpAvailability: function(dom) {
                var o = this;
                o.options.signUpID = dom;
                switch(true){
                    case dom.hasClass('consultantSignUp'):
                        $.get(
                            '/is-specialist-available',
                            {
                                id	: dom.data('id')
                            },
                            function(available, status){
                                if(!available){
                                    $("body").Vetology("vetologyLoadEnd");
                                    o._fw('showDialog', 'Unavailable', 'The Specialist that you are trying to sign-up as is already registered<br>Make sure you have entered the correct details<br>You may already have an account with us, if that is the case you can access it <a href="/">here</a>.');
                                    return;
                                }
                                o._getPlaceDetails(
                                    dom.data('id'),
                                    function(place, status){
                                        var phone_number = place.international_phone_number ? place.international_phone_number : null;
                                        if(phone_number !== null){
                                            o._loadFormConsultant(place);
                                        } else {
                                            o._loadManualForm(place);
                                        }

                                    }
                                );
                            },
                            'JSON'
                        );
                        break;
                    case dom.hasClass('shSignUp'):
                        $.get(
                            '/is-sh-available',
                            {
                                id	: dom.data('id')
                            },
                            function(available, status){
                                if(!available){
                                    $("body").Vetology("vetologyLoadEnd");
                                    o._fw('showDialog', 'Unavailable', 'The Specialty Hospital that you are trying to sign-up as is already registered<br>Please notify the account administrator so he/she can grant you access.');
                                    return;
                                }
                                o._getPlaceDetails(
                                    dom.data('id'),
                                    function(place, status){
                                        var phone_number = place.international_phone_number ? place.international_phone_number : null;
                                        if(phone_number !== null){
                                            o._loadFormSh(place);
                                        } else {
                                            o._loadManualForm(place);
                                        }
                                    }
                                );
                            },
                            'JSON'
                        );
                        break;
                    case dom.hasClass('clinicSignUp'):
                        o.signupAvailabilityClinic(dom);
                        break;
                    default:
                        break;
                }

            },
            signupAvailabilityClinic: function (dom) {
                const o = this;
                $.get(
                    '/is-clinic-available',
                    {
                        id: dom.data('id')
                    },
                    function (available, status) {
                        if (!available) {
                            $("body").Vetology("vetologyLoadEnd");
                            o._fw('showDialog', 'Unavailable', 'The Clinic that you are trying to sign-up as is already registered<br>Please notify the account administrator so he/she can grant you access.');
                            return;
                        }
                        o._getPlaceDetails(
                            dom.data('id'),
                            function (place, status) {
                                var phone_number = place.international_phone_number ? place.international_phone_number : null;
                                if (phone_number !== null) {
                                    o._loadFormClinic(place);
                                } else {
                                    o._loadManualForm(place);
                                }
                            }
                        );
                    },
                    'JSON'
                );
            },

            
            /**
             * Load Form Consultant
             * @param place
             * @private
             */
            _loadFormConsultant: function(place) {
                var o = this;
                o.options.signUpSelected = place;
                $('.mapBlock').addClass('col-md-6');
                $('.consultantSignUpForm').find('.name').val(place.name);
                $('.consultantSignUpForm').find('.website').val(place.website);
                $('.consultantSignUpForm').find('.name').html(place.name);

                var phone_number = place.international_phone_number.split(' ');
                var phone_prefix =  phone_number[0];
                phone_number.shift();

                $('.consultantSignUpForm').find(".country-code-prefix").html('(' + phone_prefix + ")");
                $('.consultantSignUpForm').find('.phone').val(place.international_phone_number).html(place.international_phone_number);
                $('.consultantSignUpForm').find('.main-phone').val(phone_number.join(' ')).html(phone_number.join(' '));
                $('.consultantSignUpForm').find('.address').val(place.formatted_address);
                $('.consultantSignUpForm').removeClass('hide');
                google.maps.event.trigger(o.options.map, 'resize');
                o.options.map.setCenter(place.geometry.location);
                o._initFormValidation('consultant');
                $("body").Vetology("vetologyLoadEnd");
            },
            /**
             * Load Form Speciality Hospital
             * @param place
             * @private
             */
            _loadFormSh: function (place){
                var o = this;
                o.options.signUpSelected = place;
                $('.mapBlock').addClass('col-md-6');
                $('.specialtyHospitalSignUpForm').find('.name').val(place.name);
                $('.specialtyHospitalSignUpForm').find('.website').val(place.website);
                $('.specialtyHospitalSignUpForm').find('.name').html(place.name);

                var phone_number = place.international_phone_number.split(' ');
                var phone_prefix =  phone_number[0];
                phone_number.shift();

                $('.specialtyHospitalSignUpForm').find(".country-code-prefix").html('(' + phone_prefix + ")");
                $('.specialtyHospitalSignUpForm').find('.phone').val(place.international_phone_number).html(place.international_phone_number);
                $('.specialtyHospitalSignUpForm').find('.main-phone').val(phone_number.join(' ')).html(phone_number.join(' '));
                $('.specialtyHospitalSignUpForm').find('.address').val(place.formatted_address);
                $('.specialtyHospitalSignUpForm').removeClass('hide');
                google.maps.event.trigger(o.options.map, 'resize');
                o.options.map.setCenter(place.geometry.location);
                o._initFormValidation('specialty');
                $("body").Vetology("vetologyLoadEnd");
            },
            /**
             * Load form Clinic signup
             * @param place
             * @private
             */
            _loadFormClinic : function (place) {
                var o = this;
                o.options.signUpSelected = place;
                $('.mapBlock').addClass('col-md-6');
                $('.clinicSignUpForm').find('.name').val(place.name);
                $('.clinicSignUpForm').find('.website').val(place.website);
                $('.clinicSignUpForm').find('.name').html(place.name);

                var phone_number = place.international_phone_number.split(' ');
                var phone_prefix =  phone_number[0];
                phone_number.shift();
                if (typeof phone_number === 'object') {
                    phone_number = phone_number[0];
                }

                $('.clinicSignUpForm').find(".country-code-prefix").html('(' + phone_prefix + ")");
                $('.clinicSignUpForm').find('.phone').val(place.international_phone_number).html(place.international_phone_number);
                $('.clinicSignUpForm').find('.main-phone').val(phone_number.replaceAll('-', ''));
                $('.clinicSignUpForm').find('.address').val(place.formatted_address);
                $('.clinicSignUpForm').removeClass('hide');
                google.maps.event.trigger(o.options.map, 'resize');
                o.options.map.setCenter(place.geometry.location);
                o._initFormValidation('clinic');
                $("body").Vetology("vetologyLoadEnd");
            },

            /**
             * Load manual form signup
             * @param place
             * @private
             */
            _loadManualForm : function (place) {
                var o = this;
                $('body').SignUpWizard('goForwardManualForm', place);
                $('body').Vetology("vetologyLoadEnd");

            },

            /*
             * vetology.map._initFormValidation
             *
             * @description	This method does a call to the clinics phone in order to validate ownership
             *
             * @param String type	The type of registration to be processed clinc|consultant|specialty
             *
             * @return NULL
             * @todo	The call implementation feature is missing, momentarily there is a mimic on it
             *			which should be replaced for a real feature, use any code to continue registration
             *
             */
            _initFormValidation: function(typ) {
                var o = this;
                $('.completeRegister').on('click', function(e){
                    e.preventDefault();
                    var el = $(this);
                    if(el.hasClass('excecuting')){
                        return;
                    }
                    $("body").Vetology("vetologyLoadStart", "Please wait while we create your account");
                    el.addClass('excecuting');
                    var clinic = o.options.signUpSelected;
                    var form = el.closest('form');
                    const type = o._getMarkerType(clinic.name, clinic.place_id);
                    var append = '';
                    switch(type){
                        case 'specialty':
                            append = 's_';
                            break;
                        case 'clinic':
                            append = '';
                            break;
                        default:
                            append = 'c_';
                            break;
                    }
                    var data = {
                        confirmation_code		: form.find('[name="' + append + 'confirmation_code"]').val(),
                        name					: form.find('[name="' + append + 'name"]').val(),
                        last					: form.find('[name="' + append + 'last"]').val(),
                        email					: form.find('[name="' + append + 'email"]').val(),
                        password				: form.find('[name="' + append + 'password"]').val(),
                        password_confirmation	: form.find('[name="' + append + 'password_confirmation"]').val(),
                        accept_auth				: form.find('[name="' + append + 'accept_auth"]').is(':checked') ? 1 : 0,
                        clinic_email			: form.find('[name="' + append + 'clinic_email"]').val(),
                        phone					: form.find('[name="' + append + 'phone"]').val(),
                        fax						: form.find('[name="' + append + 'fax"]').val(),
                        voip					: form.find('[name="' + append + 'voip"]').val(),
                        website					: form.find('[name="' + append + 'website"]').val(),
                        place_id				: clinic.place_id,
                        tPhone					: o.options.phone
                    };
                    $.ajax({
                        type		: 'POST',
                        url			: '/sign-up',
                        data		: data,
                        dataType	: 'JSON',
                        error		: function(error){
                            el.removeClass('excecuting');
                            $("body").Vetology("vetologyLoadEnd");
                            $("body").Vetology("vetologyShowDialog", "Something went wrong", "An unexpected error has occurred.<br>Please try again.", "error");
                        }
                    }).done(
                        function(data){
                            el.removeClass('excecuting');
                            if(data.valid){
                                $("body").Vetology(
                                    "vetologyShowDialog",
                                    "Success",
                                    "We have successfully created your account.<br>Click OK to continue.",
                                    "success",
                                    function(){
                                        setTimeout(function () {
                                            location.replace(data.redirect);
                                        }, 800);
                                    }
                                );
                            } else {
                                var errors = '<ul>';
                                $.each(data.errors, function(i,e){
                                    $('._' + i).addClass('has-error');
                                    errors += '<li>' + e + '</li>';
                                });
                                errors += '</ul>';
                                $("body").Vetology("vetologyShowDialog", "Error:", errors, "error");
                            }
                            $("body").Vetology("vetologyLoadEnd");
                        }
                    );
                });
                $('.makeCall').on('click', function(e){
                    e.preventDefault();
                    $('.makeCall').html('Call me again');
                    $("body").Vetology("vetologyLoadStart", "Please wait while we initiate the call");
                    $.ajax({
                        url		: '/validate-ownership',
                        method	: 'POST',
                        data	: {
                            reference	: o.options.signUpID.data('id'),
                            p			: o._fw('getUrlParam', 'p')
                        },
                        success: function(data){
                            if(!data){
                                $("body").Vetology("vetologyShowDialog", "Error", "We could not verify the phone number, please try again later.", "error");
                            } else {
                                $("body").Vetology("vetologyShowDialog", "Code Sent", "We are calling the clinic right now to provide the code, please enter it once you hear it.", "info");
                                $('.allowRegister').removeAttr('disabled');
                            }
                            $("body").Vetology("vetologyLoadEnd");
                        },
                        dataType: 'JSON'
                    });
                });
                $('.allowRegister').on('click', function(e){
                    e.preventDefault();
                    var buttonClicked = $(this);
                    var codeInput = buttonClicked.closest('form').find('.theCode');
                    var code = codeInput.val();
                    $("body").Vetology("vetologyLoadStart", "Validating, please wait...");
                    buttonClicked.html('Validating, please wait...').addClass('btn-warning').removeClass('btn-info');
                    $.ajax({
                        url		: '/validate-ownership-code',
                        method	: 'POST',
                        data	: {
                            code : code
                        },
                        success: function(data){
                            if(!data){
                                $("body").Vetology("vetologyShowDialog", "Incorrect code", "We are sorry but the code you have entered does not match.<br>Please try again.", "error");
                                buttonClicked.html('Validate').removeClass('btn-warning').addClass('btn-info');
                            } else {
                                buttonClicked.html('Succesfuly validated').removeClass('btn-info').removeClass('btn-warning').addClass('btn-success');
                                $('.clinicExtras').removeClass('hide');
                                $('.mapBlock, .allowRegister, .makeCall').addClass('hide');
                                $('.theCode').prop('disabled', true);
                                $('.completeClinicSignUp').removeClass('hide');
                                buttonClicked.closest('form').removeClass('col-md-6');
                                $('html, body').animate({
                                    scrollTop: $('.clinicExtras').offset().top
                                }, 300);
                            }
                            $("body").Vetology("vetologyLoadEnd");
                        },
                        dataType: 'JSON'
                    });
                });
            },
            /*
             * vetology.map._getPlaceDetails
             *
             * @description	This method gets and returns the Clincs information for the related @place_id.
             *
             * @param String place_id	The id of the place that detail is need of
             * @param String callback	The function that should be called once the place has been found
                                        The function should be part of this as this.function and should accept 2 parameters
                                        status and google.maps.places.PlaceResult
             *
             * @return NULL
             *
             */
            _getPlaceDetails: function(place_id, callback) {
                var o = this;
                if(typeof this.options.serviceSearch == 'undefined'){
                    this._initGeoCoding(o.options.map);
                }
                this.options.serviceSearch.getDetails(
                    {
                        placeId: place_id
                    },
                    function(place, status){
                        if(place.place_id == 'ChIJvxwBzZv_24ARbMUbxlHq1pg'){
                            place.name = 'Joe\'s Demo Clinic';
                            place.website = 'http://www.moock.net/';
                            place.formatted_phone_number = '(858) 472-1300';
                        }
                        if(place.place_id == 'ChIJSQqs-z34hlQR1D1ANo44aaQ'){
                            place.name = 'Points East West Veterinary Services';
                            place.website = 'http://pointseastwest.com/contact/';
                            place.formatted_phone_number = '(604) 898-6633';
                            place.address_components = [];
                            var c = {
                                'long_name'		: '#101, 38147',
                                'short_name'	: '#101, 38147',
                                'types'			: [
                                    'street_number'
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Cleveland Ave Box 2696',
                                'short_name'	: 'Cleveland Ave Box 2696',
                                'types'			: [
                                    'route'
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Squamish-Lillooet',
                                'short_name'	: 'Squamish-Lillooet',
                                'types'			: [
                                    'administrative_area_level_2',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'British Columbia',
                                'short_name'	: 'BC',
                                'types'			: [
                                    'administrative_area_level_1',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Squamish',
                                'short_name'	: 'Squamish',
                                'types'			: [
                                    'administrative_area_level_3',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Squamish',
                                'short_name'	: 'Squamish',
                                'types'			: [
                                    'locality',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Canada',
                                'short_name'	: 'CA',
                                'types'			: [
                                    'country',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'V8B 0A2',
                                'short_name'	: 'V8B 0A2',
                                'types'			: [
                                    'postal_code',
                                ]
                            };
                            place.address_components.push(c);
                        }
                        if(place.place_id == 'ChIJB3OPSNgYsocRotMmR1IeeyQ'){
                            place.name = 'Great Plains Veterinary Services';
                            place.website = 'http://greatplainsvet.com';
                            place.formatted_phone_number = '(405) 385-1074';
                            place.address_components = [];
                            var c = {
                                'long_name'		: '11209',
                                'short_name'	: '11209',
                                'types'			: [
                                    'street_number'
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'North Eastern Avenue',
                                'short_name'	: 'North Eastern Avenue',
                                'types'			: [
                                    'route'
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Oklahoma City',
                                'short_name'	: 'Oklahoma City',
                                'types'			: [
                                    'administrative_area_level_2',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Oklahoma',
                                'short_name'	: 'OK',
                                'types'			: [
                                    'administrative_area_level_1',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Oklahoma',
                                'short_name'	: 'Oklahoma',
                                'types'			: [
                                    'administrative_area_level_3',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'Oklahoma',
                                'short_name'	: 'Oklahoma',
                                'types'			: [
                                    'locality',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: 'United States',
                                'short_name'	: 'US',
                                'types'			: [
                                    'country',
                                    'political',
                                ]
                            };
                            place.address_components.push(c);
                            var c = {
                                'long_name'		: '73131',
                                'short_name'	: '73131',
                                'types'			: [
                                    'postal_code',
                                ]
                            };
                            place.address_components.push(c);
                        }
                        callback(place, status);
                    }

                );
            },
            /*
             * vetology.map._resizeMap
             *
             * @description	This method runs on page resize and is meant to set the correct sizing for all elements on page.
             *
             * @return NULL
             *
             */
            _resizeMap: function() {
                var o = this;
                $(window).resize(function() {
                    $('.geoMap').css(
                        {
                            'height'		: ($(window).height() - 250),
                            'min-height'	: '450px'
                        }
                    );
                });
                $(window).resize();
            },
            /*
             * vetology.map._getClinicAddButton
             *
             * @description	This method returns the correct label type for asking a clinic to join the OCR
             *
             * @param Object clinic	The type of info window needed
             *
             * @return String	The label or anchor for the clinic
             */
            _getClinicAddButton: function(clinic){
                if(typeof window.enabled_clinics == "undefined"){
                    window.enabled_clinics = {};
                }
                var el = $(".active_pms");
                var label;
                var o = this;
                var sikkaEnabled = typeof o.options.sikkaClinics[clinic.place_id] != "undefined" ? true : false;
                if(o.options._map.data('map') == "clinic_adder_pms"){
                    if(el.length > 0){
                        label = '<button class="btn btn-primary btn-block btn-xs joinNetwork2"  data-clinicname="' + clinic.name + '" data-shname="' + o.options.specialty.name + '" class="joinNetwork" data-join="' + o.options.specialty.ClinicID + '" data-id="' + clinic.place_id + '" data-type="1" href="#">If this is ' + el.html() + ' click here to complete the request.</button>';
                    } else {
                        label = '<button class="btn btn-primary btn-block btn-xs joinNetwork2"  data-clinicname="' + clinic.name + '" data-shname="' + o.options.specialty.name + '" class="joinNetwork" data-join="' + o.options.specialty.ClinicID + '" data-id="' + clinic.place_id + '" data-type="1" href="#">Add this clinic to ' + o.options.specialty.name + '\'s One Click Referral Network</button>';
                    }
                    return label;
                } else {
                    if(typeof o.options.userSHs[clinic.place_id] != 'undefined'){
                        label = '<span class="label label-info">You administer this Specialty Hospital</span>';
                    } else if($.inArray(clinic.place_id, o.options.SHs) > -1 || typeof specialtyClinics[clinic.place_id] != 'undefined'){
                        label = '<span class="label label-info">This is a Specialty Hospital</span>';
                    } else if(typeof o.options.requested[clinic.place_id] != 'undefined'){
                        label = '<span class="label label-warning">You requested this clinic to join (status: request sent)</span>';
                    } else if(typeof o.options.inNetwork[clinic.place_id] != 'undefined'){
                        label = '<a href="/specialty-hospital/manage/analytics" class="viewAnalytics label label-success">Go to Analytics</a>';
                        if((o.options.inNetwork[clinic.place_id].data_pull == 0 || !sikkaEnabled) && typeof window.enabled_clinics[clinic.place_id] == "undefined"){
                            label += '&nbsp;<a href="#" class="requestDataPull label label-info" data-clinicname="' + clinic.name + '" data-shname="' + o.options.specialty.name + '" data-join="' + o.options.specialty.ClinicID + '" data-id="' + clinic.place_id + '" data-type="1" >Get OCR data from this clinic</a>';
                        } else {
                            label += '&nbsp;<span class="label label-success">OCR data enabled for this clinic</span>';
                        }
                    } else if(typeof o.options.denied[clinic.place_id] != 'undefined'){
                        label = '<span class="label label-danger">This clinic requested to join (status: request denied)</span>';
                    } else if(typeof o.options.youDenied[clinic.place_id] != 'undefined' && typeof o.options.request[clinic.place_id] == 'undefined'){
                        label = '<span class="label label-danger">You denied this clinic to join (status: request denied)</span>';
                    } else if(typeof o.options.request[clinic.place_id] != 'undefined'){
                        var request = o.options.request[clinic.place_id];
                        label = '<a href="#" data-id="' + request.id + '" class="label label-success acceptJoinNetwork">Accept</a> or <a href="#" data-id="' + request.id + '" class="label label-danger denyJoinNetwork">Deny</a> clinic\'s request to be part of your OCR netwok';
                    } else {
                        if(el.length > 0){
                            label = '<button class="btn btn-primary btn-block btn-xs joinNetwork2"  data-clinicname="' + clinic.name + '" data-shname="' + o.options.specialty.name + '" class="joinNetwork" data-join="' + o.options.specialty.ClinicID + '" data-id="' + clinic.place_id + '" data-type="1" href="#">If this is ' + el.html() + ' click here to complete the request.</button>';
                        } else {
                            label = '<button class="btn btn-primary btn-block btn-xs joinNetwork2"  data-clinicname="' + clinic.name + '" data-shname="' + o.options.specialty.name + '" class="joinNetwork" data-join="' + o.options.specialty.ClinicID + '" data-id="' + clinic.place_id + '" data-type="1" href="#">Add this clinic to ' + o.options.specialty.name + '\'s One Click Referral Network</button>';
                        }
                    }
                    return label;
                }
            },
            /*
             * vetology.map.updateMarker
             *
             * @description	This method updates a marker on the map
             *
             * @param String place_id	The place_id related to the marker
             *
             * @return NULL
             */
            updateMarker: function(place_id, updateType, id){
                var o = this;
                if(typeof o.options.requested[place_id] != 'undefined'){
                    delete o.options.requested[place_id];
                }
                if(typeof o.options.request[place_id] != 'undefined'){
                    delete o.options.request[place_id];
                }
                if(typeof o.options.request[place_id] != 'undefined'){
                    delete o.options.request[place_id];
                }
                if(typeof o.options.youDenied[place_id] != 'undefined'){
                    delete o.options.youDenied[place_id];
                }
                if(typeof o.options.deniedNet[place_id] != 'undefined'){
                    delete o.options.deniedNet[place_id];
                }
                switch(updateType){
                    case 'clinic_request':
                        o.options.request[place_id] = {id:id};
                        break;
                    case 'clinic_accepted':
                        o.options.inNetwork[place_id] = {};
                        break;
                    case 'clinic_denied':
                        o.options.denied[place_id] = {};
                        break;
                    case 'clinic_in_network':
                        o.options.inNetwork[place_id] = {};
                        break;
                    case 'clinic_denied_by_you':
                        o.options.youDenied[place_id] = {};
                        break;
                    default:
                        /*
                         *if updateType is undefined it means the SH requested it
                         */
                        o.options.requested[place_id] = {};
                        break;
                }
                if(typeof o.options.markers[place_id] != 'undefined'){
                    /*
                     *if the marker is NOT on the map then there is nothing to update
                     */
                    var marker = o.options.markers[place_id];
                    var place = o.options.markers[place_id].clinic;
                    marker.setMap(null);
                    o.options.inMap.splice($.inArray(place_id, o.options.inMap), 1);
                    o._renderMarker(place, o.options.map, false, true);
                } else {
                    o._getPlaceDetails(
                        place_id,
                        function(clinic){
                            o._renderMarker(clinic, o.options.map, false, true);
                        }
                    );
                }
            },
            /*
             * vetology.map._showInfoMap
             *
             * @description	This method shows the information of a Clinic/Specialty or a Consultant
             *
             * @param Integer type	The type of info window needed
                                    0-2 Show the selection of the items for sign-up
             * @param Object map	The map where the infowindow will be displayed
             * @param Object marker The marker where the information of the item is stored along with coordinates
             *
             * @return NULL
             */
            _showInfoMap: function (typ, map, marker) {
                const o = this;
                var clinic = marker.clinic;
                var content = '';
                var markerType = this._getMarkerType(clinic.name, clinic.place_id);
                var name = clinic.name.toLowerCase();
                const type = parseInt($('.geoMap').data('type'), 10);
                if(type === 4){
                    return;
                }
                var icon;
                var color;
                var textSignup;
                if(markerType === 'consultant') {
                    icon = 'consultants';
                    color = 'green';
                    textSignup = type === 0 ? '<a data-id="' + clinic.place_id + '" class="progress-description consultantSignUp itemSignUp" href="#">Click here to sign up as this Consultant' :
                        (
                            type === 1 ? 'The item selected is a Consultant.<br>You may only sign up as a Specialty Hospital with a Specialty Hospital related record.</a>' :
                                'The item selected is a Consultant.<br>You may only sign up as a Clinic with a Clinic related record.</a>'
                        );
                } else if(markerType === 'specialty'){
                    icon = 'specialty-hospital';
                    color = 'red';
                    textSignup = type === 1 ? '<a data-id="' + clinic.place_id + '" class="progress-description shSignUp itemSignUp" href="#">Click here to sign up as this Specialty Hospital' :
                        (
                            type === 0 ? 'The item selected is a Specialty Hospital.<br>You may only sign up as a Consultant with a Consultant related record.</a>' :
                                'The item selected is a Specialty Hospital.<br>You may only sign up as a Clinic with a Clinic related record.</a>'
                        );
                } else if(markerType === 'own_specialty'){
                    icon = 'specialty-hospital';
                    color = 'red';
                    textSignup = type === 1 ? '<a data-id="' + clinic.place_id + '" class="progress-description shSignUp itemSignUp" href="#">Click here to sign up as this Specialty Hospital' :
                        (
                            type === 0 ? 'The item selected is a Specialty Hospital.<br>You may only sign up as a Consultant with a Consultant related record.</a>' :
                                'The item selected is a Specialty Hospital.<br>You may only sign up as a Clinic with a Clinic related record.</a>'
                        );
                } else {
                    icon = 'clinic';
                    color = 'aqua';
                    textSignup = type === 2 ? '<a data-id="' + clinic.place_id + '" class="progress-description clinicSignUp itemSignUp video_help_toggler" data-video="after_click_on_clinic" href="#">Click here to sign up as this Clinic' :
                        (
                            type === 0 ? 'The item selected is a Clinic.<br>You may only sign up as a Consultant with a Consultant related record.</a>' :
                                'The item selected is a Clinic.<br>You may only sign up as a Specialty Hospital with a Specialty Hospital related record.</a>'
                        );
                }
                ({ content, color } = o.showInfoMapGetContent(type, content, color, icon, clinic, textSignup, markerType, map, marker));
            },

            showInfoMapGetContent: function(type, content, color, icon, clinic, textSignup, markerType, map, marker) {
                    switch(true) {
                    case type < 3 && type > -1:
                    content = '' +
                    '<div class="info-box">' +
                    '<span class="info-box-icon bg-' + color + '"><i class="vetology-' + icon + '"></i></span>' +
                    '<div class="info-box-content">' +
                    '<span class="info-box-text">' + clinic.name + '</span>' +
                    '<span class="info-box-number"><small>' + clinic.vicinity + '</small></span>' +
                    '<div class="progress">' +
                    '<div style="width: 100%" class="progress-bar"></div>' +
                    '</div>' +
                    textSignup +
                    '</div>' +
                    '</div>';
                    break;
                    case type === 3:
                    color = markerType == 'clinic_requested' || markerType == 'clinic_request' ? 'yellow' : (markerType == 'clinic_denied' || markerType == 'clinic_denied_by_you' ? 'red' : (markerType == 'clinic_accepted' ? 'green' : color));
                    content = '' +
                    '<div class="info-box">' +
                    '<span class="info-box-icon bg-' + color + '"><i class="vetology-' + icon + '"></i></span>' +
                    '<div class="info-box-content">' +
                    '<span class="info-box-text">' + clinic.name + '</span>' +
                    '<span class="info-box-number"><small>' + clinic.vicinity + '</small></span>' +
                    '<div class="progress">' +
                    '<div style="width: 100%" class="progress-bar"></div>' +
                    '</div>' +
                    this._getClinicAddButton(clinic) +
                    '</div>' +
                    '</div>';
                    break;
                    default:
                        break;
                }
                this.options.info.setContent(content);
                this.options.info.open(map, marker);
                return { content, color };
            },

            /*
             * vetology.map._addToOCRNetwork
             *
             * @description	This method returns the anchor to add a clinic to OCR or notify that the Clinic is not available
             *
             * @param Object clinic	The Clinic that shoult be used to render the anchor
             *
             * @return String	The anchor used to add the Clinic or a note about the reason why it can't be added
             *
             */
            _addToOCRNetwork: function(clinic) {
                var label;
                var markerType = this._getMarkerType(clinic.name, clinic.place_id);
                if(markerType === 'specialty'){
                    label = '<span class="label label-info">This is a Specialty Hospital</span>';
                } else if(markerType === 'consultant') {
                    label = '<span class="label label-info">This is a DVM</span>';
                } else if(markerType === 'clinic_accepted') {
                    label = '<span class="label label-success">This Clinic is part of your OCR Network</span>';
                } else if(markerType === 'clinic_denied') {
                    label = '<span class="label label-danger">You requested this clinic to join (status: invitation denied)</span>';
                } else if(markerType === 'clinic_requested') {
                    label = '<span class="label label-warning">You requested this clinic to join (status: invitation sent)</span>';
                } else if(markerType === 'clinic') {
                    label = '<button class="btn btn-primary btn-block btn-xs joinNetwork" data-details="' + clinic + '" data-id="' + clinic.place_id + '">Add this clinic to VICSD\'s Specialty Hospital\'s One Click Referral Network</button>';
                }
                return label;
            },
            /*
             * vetology.map._initMap
             *
             * @description	This method should be excecuted only if a map element is found on page and will insert the map script.
             *
             * @return NULL
             *
             */
            _initMap: function() {
                var o = this;
                let apiKey = '';
                fetch('/api/gmap/get-api-key', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }).then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok.');
                }).then((json) => {
                    if (json.status == 'success') {
                        apiKey = json.data;
                        $.getScript('https://maps.googleapis.com//maps/api/js?key=' + apiKey + '&libraries=geometry,places')
                        .done(function(){
                            o.options.availability_google_maps = true;
                            $.getScript(
                                '/vetology_asset/js_vendor/Google/v3-utility-library/markerwithlabel/markerwithlabel.js',
                                function(){
                                    o._renderMap();
                                })
                        })
                        .fail(function(){
                            console.error("Google maps cannot be loaded.");
                        });
                    } else {
                        console.error('There has been a problem with your fetch operation.  Google maps cannot be opened:', json);
                    }
                }).catch((error) => {
                    console.error('There has been a problem with your fetch operation:', error);
                });
             },
            /*
             * vetology.map.initAnalytics
             *
             * @description	Search for Clinics near by @latLng.
             *
             * @return NULL
             *
             */
            initAnalytics: function(){
                if(typeof window.analytics_data != 'undefined'){
                    var service = new google.maps.places.PlacesService(this.options.map);
                    var o = this;
                    o.options.trends = window.analytics_data.rawAnalytics;
                    $.each(o.options.trendMarkers, function(i,e){
                        e.setMap(null);
                    });
                    $.each(o.options.trends, function(i,e){
                        o._renderAnalyticsMarker(e, true);
                    });
                    var latlng = new google.maps.LatLng(o.options._map.data('lat'), o.options._map.data('lng'));
                    var label = '<span class="vmapMarker vetology-specialty-hospital specialty-hospitalMarker"></span>';
                    var settings = {
                        'trigger'	: 'hover',
                        'placement'	: 'auto',
                        'html'		: true,
                        'container'	: 'body',
                        'content'	: o.options._map.data("title") + " OCR network",
                    };
                    var marker = new MarkerWithLabel(
                        {
                            position		: latlng,
                            draggable		: true,
                            raiseOnDrag		: false,
                            icon			: ' ',
                            map				: this.options.map,
                            labelAnchor		: new google.maps.Point(28, 25),
                            labelContent	: label,
                            labelClass		: ' clinicMarkerLabel '
                        }
                    );
                    o.options.trendMarkers.push(marker);
                    marker.setZIndex(999);
                    /*google.maps.event.addListener(marker,'mouseover',function(e){
                        if(!label.hasClass('withPop')){
                            label.popover(settings).popover('show');
                            label.addClass('withPop');
                        } else {
                            label.popover('show');
                        }
                    });
                    google.maps.event.addListener(marker,'mouseout',function(e){
                        if(label.hasClass('withPop')){
                            label.popover('hide');
                        }
                    });*/
                    google.maps.event.addListener(marker,'click',function(e){
                        if(!label.hasClass('withPop')){
                            label.popover(settings).popover('show');
                            label.addClass('withPop');
                        } else {
                            label.popover('show');
                        }
                    });
                }
            },
            /*
             * vetology.map._getSpecialtyHospitals
             *
             * @description	Search for Clinics near by @latLng.
             *
             * @return NULL
             *
             */
            _getSpecialtyHospitals: function(latLng){
                var o = this;
                var serviceSearch = new google.maps.places.PlacesService(document.createElement('div'));
                var request = {
                    location	: latLng,
                    radius		: 50000,
                    type		: 'veterinary_care',
                    keywords	: ['clinic','veterinary','hospital','emergency']
                };
                serviceSearch.nearbySearch(
                    request,
                    function(results, status, pagination){
                        if(status == 'OK'){
                            if(pagination !== null && pagination.hasNextPage){
                                setTimeout(
                                    function(){
                                        pagination.nextPage();
                                    },
                                    2000
                                );
                            }
                            $.each(results, function(i,e){
                                el.find('.noSpec').remove();
                                var titleL = e.name.toLowerCase();
                                if(
                                    (
                                        titleL.indexOf("eye care for animals") >= 0 ||
                                        titleL.indexOf("emergency") >= 0 ||
                                        titleL.indexOf("urgent") >= 0 ||
                                        titleL.indexOf("referral") >= 0 ||
                                        titleL.indexOf("specialtie") >= 0 ||
                                        titleL.indexOf("specialist") >= 0 ||
                                        titleL.indexOf("specialty") >= 0
                                    )
                                    && titleL.indexOf("dvm") == -1
                                )
                                {
                                    el.find('ul').append('' +
                                        '<li>' +
                                        '<button class="btn btn-xs btn-block btn-primary oneClickReferral" data-url="ocr?case=' + el.data('id') + '&sh=0">' +
                                        '<span class="button_text">&nbsp;' + e.name + '&nbsp;</span>' +
                                        '</button>' +
                                        '</li>'
                                    );
                                }
                            });
                        }
                    }
                );
            },
            /*
             * vetology.map._renderMap
             *
             * @description	This method renders the map, should be excecuted only once.
             *
             * @return NULL
             *
             */
            _renderMap: function() {
                /*
                 * Create a map centered in VICSD if no coordinates were added to the map.
                 *
                 */
                var o = this;
                var invite = o._fw('getUrlParam', 'invite');
                o.options.phone = o._fw('getUrlParam', 'p');
                if(o.options.phone != false){
                    o.options.phone = o.options.phone.replace(/\D/g,'');
                    if(o.options.phone.length < 10){
                        o.options.phone = false;
                        alert('The phone number you are using for calling is not valid and will not be used\nIf you want to use your number enter the 10 digits.');
                    }
                }
                if(typeof o.options._map.data('lng') != 'undefined' && o.options._map.data('lng') != ''){
                    o.options.coordinates = {
                        lat	: parseFloat(o.options._map.data('lat')),
                        lng	: parseFloat(o.options._map.data('lng'))
                    };
                } else {
                    o.options.coordinates = {
                        lat	: 32.833502,
                        lng	: -117.156921
                    };
                }
                var MapParameters = {
                    center			: o.options.coordinates,
                    zoom			: typeof o.options._map.data('zoom') != 'undefined' ? o.options._map.data('zoom') : o.options.initialZoom,
                    minZoom			: typeof o.options._map.data('minzoom') != 'undefined' ? o.options._map.data('minzoom') : o.options.minimumZoom,
                    maxZoom			: typeof o.options._map.data('maxzoom') != 'undefined' ? o.options._map.data('maxzoom') : 21,
                    disableDefaultUI: typeof o.options._map.data('ui') != 'undefined',
                    draggable		: typeof o.options._map.data('ui') == 'undefined'
                };
                o.options.map = new google.maps.Map(
                    o.options.map,
                    MapParameters
                );
                o.options.map.addListener('zoom_changed', function(e) {
                    var classNames = o.options._map.attr('class').replace(/\zoomL.*?\b/g, '');
                    o.options._map.attr('class', classNames);
                    o.options._map.addClass('zoomL' + o.options.map.getZoom());
                    $('.popover').remove();
                });
                switch(o.options._map.data('map')){
                    case 'signup':
                        o.options.map.addListener('click', function(e) {
                            $('.popover').remove();
                        });
                        break;
                    case 'welcome':
                        o.options.map.addListener('click', function(e) {
                            $('.popover').remove();
                        });
                        o._initWelcomeSearch();
                        break;
                    case 'analytics':
                        o.options.map.addListener('click', function(e) {
                            $('.popover').remove();
                        });
                        o.initAnalytics();
                        break;
                    case 'clinic_adder':
                        o.options.marker = new MarkerWithLabel(
                            {
                                position		: o.options.coordinates,
                                draggable		: true,
                                raiseOnDrag		: true,
                                icon			: ' ',
                                map				: o.options.map,
                                labelAnchor		: new google.maps.Point(28, 25),
                                labelContent	: '<span title="New Clinic" data-content="New Clinic" class="vmapMarker doPop vetology-clinic newClinic"></span>',
                                labelClass		: ' clinicMarkerLabel '
                            }
                        );
                        o.options.marker.clinic = null;
                        o.options.marker.addListener('dragend', function(e) {
                            $('.place_finder_lat').val(e.latLng.lat());
                            $('.place_finder_lng').val(e.latLng.lng());
                            o._geoLocateData($('.place_finder_lng'));
                        });
                        break;
                    case 'clinic_adder_pms':
                        $(".geoMap").append("<div class=\"pms_selector\"></div>");
                        $(".pms_selector").append("<p>The below clinics are not getting automatic case distribution. Select a clinic from below to get started: <a target=\"_blank\" href=\"/doc/automatic-case-distribution\" class=\"vetology-faq\"></a></p>");
                        $.each(o.options.pms_clinics, function(i, clinic){
                            var a = $('<a></a>');
                            a.attr("href", "#");
                            a.attr("class", "clinic_pms_adder");
                            a.data("clinic", clinic);
                            a.html(clinic);
                            $(".pms_selector").append(a);
                        });
                        break;
                    default:
                        o.options.map.addListener('click', function(e) {
                            $('.popover').remove();
                        });
                        o.options.map.addListener('center_changed', function(e) {
                            o._runServiceSearch();
                        });
                        o.options.map.addListener('bounds_changed', function(e) {
                            o._runServiceSearch();
                        });
                        o._runServiceSearch();
                        break;
                }
                google.maps.event.trigger(o.options.map, 'zoom_change');
                if(invite !== false){
                    o._getPlaceDetails(
                        invite,
                        function(place,status){
                            if(status == 'OK'){
                                place.type = o._getMarkerType(place.name, place.place_id);
                                var streetNumber = '';
                                var streetName = '';
                                $.each(place.address_components, function(i, e){
                                    if($.inArray('street_number', e.types) > -1){
                                        streetNumber += e.long_name + ' ';
                                    } else if($.inArray('route', e.types) > -1){
                                        streetName += e.long_name;
                                    } else if($.inArray('locality', e.types) > -1){
                                        $('.city').val(e.long_name);
                                    } else if($.inArray('administrative_area_level_1', e.types) > -1){
                                        $('.address_state').val(e.long_name);
                                    } else if($.inArray('postal_code', e.types) > -1){
                                        $('.postal_code').val(e.long_name);
                                    }
                                });
                                $('.street_name').val(streetNumber + streetName);
                                o.options.map.setZoom(17);
                                o._renderMarker(place, true);
                                $('.mapBlock').removeClass('disabledSection');
                            }
                        }
                    );
                }

                /*Search for autocomplete field and render if found*/
                o.renderMapSearchAutocomplete();
                //o._fw('log', 'The map has been succesfully initialized', 'info');
                o.options.info = new google.maps.InfoWindow();
                o._addMapControls();
            },

            renderMapSearchAutocomplete: function () {
                const o = this;
                    o.options.autocomplete = $(".auto_find_by_name");
                    if(o.options.autocomplete.length > 0) {
                        /*will only initialize one field per page, if more fields are present they are to be removed*/
                        o.options.autocomplete = new google.maps.places.Autocomplete(o.options.autocomplete[0], { types: ['establishment'] });
                        o.options.autocomplete.addListener('place_changed', function () {
                            var place = o.options.autocomplete.getPlace();
                        place.type = o._getMarkerType(place.name, place.place_id);
                        var streetNumber = '';
                        var streetName = '';
                        $.each(place.address_components, function (i, e) {
                            if ($.inArray('street_number', e.types) > -1) {
                                streetNumber += e.long_name + ' ';
                            } else if ($.inArray('route', e.types) > -1) {
                                streetName += e.long_name;
                            } else if ($.inArray('locality', e.types) > -1) {
                                $('.city').val(e.long_name);
                            } else if ($.inArray('administrative_area_level_1', e.types) > -1) {
                                $('.address_state').val(e.long_name);
                            } else if ($.inArray('postal_code', e.types) > -1) {
                                $('.postal_code').val(e.long_name);
                            }
                        });
                        $('.street_name').val(streetNumber + streetName);
                        o.options.map.setZoom(17);
                        o._renderMarker(place, true);
                        $('.mapBlock').removeClass('disabledSection');
                    });
                }
            },


            /*
             * vetology.map._addMapControls
             *
             * @description	This method appends all controls needed into the document and then initializes them.
             *
             * @return NULL
             *
             */
            _addMapControls: function() {
                var o = this;
                var mtype = parseInt(o.options._map.data('type'), 10);
                switch(mtype){
                    case 3:
                        $('body').append('' +
                            '<div id="vetologyMapToolBox" class="form-group">' +
                            '<label class="btn btn-sm btn-info btn-flat disabled">Toggle Visibility</label>' +
                            '<div class="btn-group" data-toggle="buttons">' +
                            '<label class="btn btn-sm btn-success btn-flat doPop clinicIconToggler" data-toggle="popinfo" data-content="Show/Hide Clinics">' +
                            '<span class="vetology-clinic"></span>' +
                            '</label>' +
                            '<label class="btn btn-sm btn-success btn-flat doPop consultantIconToggler" data-toggle="popinfo" data-content="Show/Hide Consultants">' +
                            '<span class="vetology-consultants"></span>' +
                            '</label>' +
                            '<label class="btn btn-sm btn-success btn-flat doPop shIconToggler" data-toggle="popinfo" data-content="Show/Hide Specialty Hospitals">' +
                            '<span class="vetology-specialty-hospital"></span>' +
                            '</label>' +
                            '</div>' +
                            '</div>'
                        );
                        $('#vetologyMapToolBox').find('.mapToolsToggler').click();
                        var toolBox = document.getElementById('vetologyMapToolBox');
                        o.options.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(toolBox);
                        $('.clinicIconToggler').on('click', function(e){
                            e.preventDefault();
                            var icons = $(this);
                            if(icons.closest('label').hasClass('btn-success')){
                                icons.closest('label').removeClass('btn-success').addClass('btn-danger');
                                $('.geoMap').addClass('hideClinics');
                            } else {
                                icons.closest('label').removeClass('btn-danger').addClass('btn-success');
                                $('.geoMap').removeClass('hideClinics');
                            }
                        });
                        $('.consultantIconToggler').on('click', function(e){
                            e.preventDefault();
                            var icons = $(this);
                            if(icons.closest('label').hasClass('btn-success')){
                                icons.closest('label').removeClass('btn-success').addClass('btn-danger');
                                $('.geoMap').addClass('hideConsultants');
                            } else {
                                icons.closest('label').removeClass('btn-danger').addClass('btn-success');
                                $('.geoMap').removeClass('hideConsultants');
                            }
                        });
                        $('.shIconToggler').on('click', function(e){
                            e.preventDefault();
                            var icons = $(this);
                            if(icons.closest('label').hasClass('btn-success')){
                                icons.closest('label').removeClass('btn-success').addClass('btn-danger');
                                $('.geoMap').addClass('hideSHs');
                            } else {
                                icons.closest('label').removeClass('btn-danger').addClass('btn-success');
                                $('.geoMap').removeClass('hideSHs');
                            }
                        });
                        $('#vetologyMapToolBox').find('.consultantIconToggler').click();
                        $('body').append('' +
                            '<div id="showVetologyMapsLegends">' +
                            '<button class="btn btn-sm btn-flat btn-info">' +
                            'Labels ' +
                            '<span class="vetology-information"></span>' +
                            '</button>' +
                            '&nbsp;&nbsp;' +
                            '</div>'
                        );
                        $('#showVetologyMapsLegends button').popover(
                            {
                                html : true,
                                content: function() {
                                    return '' +
                                        '<ul class="list-group">' +
                                        '<li class="list-group-item"><span class="vetology-clinic legendClinc"></span> Clinic</li>' +
                                        '<li class="list-group-item"><span class="vetology-specialty-hospital legendClinc specialty"></span> Specialty Hospital</li>' +
                                        '<li class="list-group-item"><span class="vetology-consultants legendClinc consultant"></span> Consultant, DVM</li>' +
                                        '<li class="list-group-item"><span class="vetology-clinic legendClinc requestPending"></span> You requested this clinic to join your network and their invitation is awaiting response</li>' +
                                        '<li class="list-group-item"><span class="vetology-clinic legendClinc requestDenied"></span> You requested this clinic to join your network and their invitation was denied</li>' +
                                        '<li class="list-group-item"><span class="vetology-clinic legendClinc requestAccepted"></span> This clinic is part of your referral network, click to view analytics</li>' +
                                        '</ul>' +
                                        '';
                                },
                                title		: 'Label Information',
                                placement	: 'left',
                                container	: 'body',
                                viewport	: '.geoMap'
                            }
                        );
                        var control = document.getElementById('showVetologyMapsLegends');
                        o.options.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
                        break;
                    case 4:
                        o.addMapControlsMtype4();
 
                        break;
                }
                $('.toggleSHRadius').on('click', function(){
                    var el = $(this);
                    if(el.hasClass('btn-success')){
                        if(typeof specialtyRadius != 'undefined'){
                            specialtyRadius.setVisible(false);
                        }
                        el.removeClass('btn-success').addClass('btn-danger');
                    } else {
                        if(typeof vetologyMap.specialtyRadius != 'undefined'){
                            vetologyMap.specialtyRadius.setVisible(true);
                        }
                        el.removeClass('btn-danger').addClass('btn-success');
                    }
                });
                $('.showMapSettings').on('click', function(){
                    $('.mapSettings').toggleClass('show');
                });
                $('body').on('click', '.clinicAdder', function(e){
                    e.preventDefault();
                    $("body").Vetology("vetologyLoadStart");
                    $.ajax({
                        url: '/addClinic',
                        data: {
                            clinic : $(this).data('id')
                        },
                        success: function(data){
                            $("body").Vetology("vetologyLoadEnd");
                            o.updateMarker(data.clinic);
                        },
                        dataType: 'JSON'
                    });
                });
                document.body.addEventListener('mousedown', event => {
                    document.body.dataset.mousedown = '1';
                });
                document.body.addEventListener('mouseup', event => {
                    const _self = this;
                    document.body.dataset.mousedown = '0';
                    _self._runServiceSearch();
                });
            },
            addMapControlsMtype4: function () {
                const o = this;
                o.options.geocoder = new google.maps.Geocoder();
                o.options.service = new google.maps.places.PlacesService(o.options.map);

                if (window.hasPrivilegesAddClinicInfo === true) {
                    $('body').append('' +
                        '<div class="map_search_inputs">' +
                        '<select class="place_finder_country" ><option disabled="disabled" selected="selected">First set country or coordinates</option><option value="AF">Afghanistan</option><option value="AX">Åland Islands</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia, Plurinational State of</option><option value="BQ">Bonaire, Sint Eustatius and Saba</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="BN">Brunei Darussalam</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="CV">Cape Verde</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo</option><option value="CD">Congo, the Democratic Republic of the</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="CI">Côte d\'Ivoire</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands (Malvinas)</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="VA">Holy See (Vatican City State)</option><option value="HN">Honduras</option><option value="HK">Hong Kong</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran, Islamic Republic of</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KP">Korea, Democratic People\'s Republic of</option><option value="KR">Korea, Republic of</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Lao People\'s Democratic Republic</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao</option><option value="MK">Macedonia, the former Yugoslav Republic of</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia, Federated States of</option><option value="MD">Moldova, Republic of</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory, Occupied</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RE">Réunion</option><option value="RO">Romania</option><option value="RU">Russian Federation</option><option value="RW">Rwanda</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena, Ascension and Tristan da Cunha</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin (French part)</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten (Dutch part)</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syrian Arab Republic</option><option value="TW">Taiwan, Province of China</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania, United Republic of</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VE">Venezuela, Bolivarian Republic of</option><option value="VN">Viet Nam</option><option value="VG">Virgin Islands, British</option><option value="VI">Virgin Islands, U.S.</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option></select>' +
                        '<input type="text" class="place_finder_lat" placeholder="Latitude">' +
                        '<input type="text" class="place_finder_lng" placeholder="Longitude">' +
                        '<br>' +
                        '<input disabled="disabled" type="text" class="place_finder_state" placeholder="State/Region">' +
                        '<input disabled="disabled" type="text" class="place_finder_city" placeholder="City">' +
                        '<input disabled="disabled" type="text" class="place_finder_zip" placeholder="ZIP/Postal Code">' +
                        '<input disabled="disabled" type="text" class="place_finder_address" placeholder="Street Address" data-s="" data-n="">' +
                        '<input disabled="disabled" type="text" class="place_finder_name" placeholder="Name" value="New Clinic">' +
                        '<input disabled="disabled" type="text" class="place_finder_phone" placeholder="Phone" value="">' +
                        '<input disabled="disabled" type="text" class="place_finder_fax" placeholder="Fax" value="">' +
                        '<input disabled="disabled" type="text" class="place_finder_pid" placeholder="Place ID" value="">' +
                        '<button class="addClinicNow">Add clinic</button>' +
                        '<div class="contactUsContainer">' +
                        '<span class="contactUs">Having trouble? Please </a><a href="/doc/contact-us" class="contactUs">contact us.</a>' +
                        '</div>' +
                        '<div>'
                    );
                    $('.map_search_inputs').on('change', '.place_finder_country', function () {
                        //Changing the marker label in case the user selects other country
                        o.options.marker.set('labelContent', '<span data-content="Location for the new clinic" class="vmapMarker doPop vetology-clinic ownClinic"></span>');
                        $('.clinic_list').html('');

                        $('.place_finder_state').val('');
                        $('.place_finder_city').val('');
                        $('.place_finder_zip').val('');
                        $('.place_finder_address').val('');
                        $('.place_finder_name').val('');
                        $('.place_finder_phone').val('');
                        $('.place_finder_fax').val('');
                        $('.place_finder_lat').val('');
                        $('.place_finder_lng').val('');
                        $('.place_finder_pid').val('');

                        $('.place_finder_name').attr('disabled', 'disabled');
                        $('.place_finder_address').attr('disabled', 'disabled');
                        $('.place_finder_city').attr('disabled', 'disabled');
                        $('.place_finder_state').attr('disabled', 'disabled');
                        $('.place_finder_zip').attr('disabled', 'disabled');
                        $('.place_finder_phone').attr('disabled', 'disabled');
                        $('.place_finder_fax').attr('disabled', 'disabled');

                        o.options.geocoder.geocode(
                            { 'address': $(this).find('option:selected').text() },
                            function (results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    $('.place_finder_state').removeAttr('disabled');

                                    o.options.map.setZoom(5);
                                    o.options.marker.setPosition(results[0].geometry.location);
                                    o.options.map.setCenter(results[0].geometry.location);
                                }
                            }
                        );
                    });
                    $('body').on('click', '.clinic_list a', function (e) {
                        e.preventDefault();
                        var service = new google.maps.places.PlacesService(o.options.map);
                        var place_id = $(this).data('id');
                        service.getDetails({ placeId: place_id }, function (place) {

                            $('.place_finder_name').val(place.name);
                            $('.place_finder_phone').val(place.international_phone_number);
                            $('.place_finder_fax').val(place.international_phone_number);
                            $('.place_finder_pid').val(place_id);
                            $('.place_finder_lat').val(place.geometry.location.lat());
                            $('.place_finder_lng').val(place.geometry.location.lng());

                            o.options.map.setZoom(15);
                            o.options.map.setCenter(place.geometry.location);
                            o.options.marker.setPosition(place.geometry.location);

                            var ac = place.address_components;
                            $.each(ac, function (i, c) {
                                if (c.types[0] == 'country' || (typeof c.types[1] != 'undefined' && c.types[1] == 'country')) {
                                    $('.place_finder_country').val(c.short_name);
                                    $('.place_finder_state').removeAttr('disabled');
                                } else if (c.types[0] == 'administrative_area_level_1' || (typeof c.types[1] != 'undefined' && c.types[1] == 'administrative_area_level_1')) {
                                    $('.place_finder_country').val(c.short_name);
                                    $('.place_finder_state').removeAttr('disabled');
                                } else if (c.types[0] == 'locality' || (typeof c.types[1] != 'undefined' && c.types[1] == 'locality')) {
                                    $('.place_finder_city').val(c.short_name).removeAttr('disabled');
                                    $('.place_finder_zip').removeAttr('disabled');
                                } else if (c.types[0] == 'postal_code') {
                                    o.options.map.setZoom(15);
                                    $('.place_finder_zip').val(c.short_name).removeAttr('disabled');
                                    $('.place_finder_address').removeAttr('disabled');
                                    $('.place_finder_name').removeAttr('disabled');
                                } else if (c.types[0] == 'route') {
                                    o.options.map.setZoom(17);
                                    $('.place_finder_address').data('s', c.short_name);
                                    $('.place_finder_address').val($('.place_finder_address').data('n') + ' ' + $('.place_finder_address').data('s'));
                                } else if (c.types[0] == 'street_number') {
                                    o.options.map.setZoom(17);
                                    $('.place_finder_address').data('n', c.short_name);
                                    $('.place_finder_address').val($('.place_finder_address').data('n') + ' ' + $('.place_finder_address').data('s'));
                                }
                            });
                        });
                    });
                    var control = $('.map_search_inputs')[0];
                    var input = $('.place_finder')[0];
                    o.options.map.controls[google.maps.ControlPosition.TOP_LEFT].push(control);
                    $('.map_search_inputs').on('keyup', 'input', function () {
                        o._geoLocateData($(this));

                        //Changing the marker label in case the user fill values in the Add clinic form
                        o.options.marker.set('labelContent', '<span data-content="Location for the new clinic" class="vmapMarker doPop vetology-clinic ownClinic"></span>');
                    });
                }
                $('body').append('' +
                    '<div id="showVetologyMapsLegends">' +
                    '<button class="btn btn-sm btn-flat btn-info">' +
                    'Labels ' +
                    '<span class="vetology-information"></span>' +
                    '</button>' +
                    '&nbsp;&nbsp;' +
                    '</div>'
                );
                $('#showVetologyMapsLegends button').popover(
                    {
                        html: true,
                        content: function () {
                            return '' +
                                '<ul class="list-group">' +
                                '<li class="list-group-item"><span class="vetology-clinic legendClinc"></span> Clinic</li>' +
                                '<li class="list-group-item"><span class="vetology-specialty-hospital legendClinc specialty"></span> Specialty Hospital</li>' +
                                '<li class="list-group-item"><span class="vetology-consultants legendClinc consultant"></span> Consultant, DVM</li>' +
                                '<li class="list-group-item"><span class="vetology-clinic legendClinc requestPending"></span> You requested this clinic to join your network and their invitation is awaiting response</li>' +
                                '<li class="list-group-item"><span class="vetology-clinic legendClinc requestDenied"></span> You requested this clinic to join your network and their invitation was denied</li>' +
                                '<li class="list-group-item"><span class="vetology-clinic legendClinc requestAccepted"></span> This clinic is part of your referral network, click to view analytics</li>' +
                                '</ul>' +
                                '';
                        },
                        title: 'Label Information',
                        placement: 'left',
                        container: 'body',
                        viewport: '.geoMap'
                    }
                );
                var control = document.getElementById('showVetologyMapsLegends');
                o.options.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);

            },

            /*
             * Vetology.gmap.getAvailabilityGmaps
             *
             * @description	returns the availability of the gmap resource
             *
             * @return NULL
             *
             */
            getAvailabilityGmaps: function(){
                var o = this;
                return o.options.availability_google_maps;
            }
        }
    );
})(jQuery);







